<template>
  <div id="my-header">
    <div class="main-preloader" v-if="showPreloader || statusPreloader">
      <lottie-animation
          ref="preloader"
          :animationData="require('@/assets/img/Loader.json')"
          :loop="true"
          :autoPlay="true"
          :speed="1"
      />
    </div>
    <div class="testing-button-from-demo" v-show="token && !isClaimToken">
      <a @click="sendTransactionMaticPopup">
        <!--          {{ $t('Deposit funds into your metamask') }}-->
        {{ $t('Claim USDT token') }}
        <svg class="login-button-img" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_8992_223338)">
            <path d="M12 1C18.0744 1 23 5.92556 23 12C23 18.0744 18.0744 23 12 23C5.92556 23 1 18.0775 1 12C1 5.9225 5.92556 1 12 1Z" fill="#26A17B"/>
            <path d="M13.5489 10.7735V9.13575H17.292V6.64246H7.10165V9.13575H10.8447V10.7735C7.80443 10.9141 5.51581 11.516 5.51581 12.2371C5.51581 12.9582 7.80443 13.5601 10.8447 13.7007V18.9409H13.552V13.7007C16.5892 13.5601 18.8717 12.9582 18.8717 12.2371C18.8686 11.516 16.5861 10.9141 13.5489 10.7735ZM13.552 13.2576C13.4756 13.2607 13.0845 13.2851 12.2106 13.2851C11.5108 13.2851 11.0219 13.2668 10.8478 13.2576V13.2607C8.16193 13.1415 6.15442 12.674 6.15442 12.1149C6.15442 11.5557 8.15888 11.0882 10.8478 10.9691V12.7901C11.025 12.8024 11.5261 12.8329 12.2228 12.8329C13.057 12.8329 13.4756 12.7993 13.555 12.7901V10.9629C16.2378 11.0821 18.2392 11.5496 18.2392 12.1088C18.2331 12.6679 16.2317 13.1354 13.552 13.2576Z" fill="white"/>
          </g>
          <defs>
            <clipPath id="clip0_8992_223338">
              <rect width="22" height="22" fill="white" transform="translate(1 1)"/>
            </clipPath>
          </defs>
        </svg>
      </a>
      <!--        <a @click="showLeaderboard">-->
      <!--          &lt;!&ndash;          {{ $t('Deposit funds into your metamask') }}&ndash;&gt;-->
      <!--          {{ $t('Leaderboard') }}-->
      <!--          <img src="@/assets/img/leaderboard-icon.png" alt="user image" class="login-button-img">-->
      <!--        </a>-->
    </div>
    <v-theme-provider root>
      <header class="header">
        <div class="container-full" >
          <div class="header-wrapper">
            <div class="header-logo-wrap">
              <a @click="$router.push('/swaps').catch(() => {})">
                <svg width="132" height="40" viewBox="0 0 132 40" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="!dexLogoShort">
                  <path d="M80.9169 13.3814L83.6353 9.32117L85.7912 10.6239L83.9719 13.4539L83.4983 14.1385H80.3921L80.9169 13.3814Z" fill="#42E8E0"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M109.223 27.355C108.266 27.355 107.379 27.1935 106.559 26.8707C105.739 26.5354 105.025 26.0697 104.417 25.4737C103.808 24.8776 103.33 24.1698 102.983 23.3502C102.647 22.5306 102.48 21.6303 102.48 20.6493V20.5003C102.505 19.569 102.678 18.7059 103.001 17.9112C103.337 17.1164 103.802 16.4272 104.398 15.8436C104.994 15.2475 105.702 14.7819 106.522 14.4466C107.354 14.1113 108.279 13.9437 109.297 13.9437H109.428C110.483 13.9437 111.421 14.1175 112.24 14.4652C113.072 14.8129 113.774 15.2848 114.345 15.8809C114.916 16.4769 115.345 17.1723 115.63 17.9671C115.928 18.7618 116.077 19.6062 116.077 20.5003V20.6493C116.077 21.6303 115.903 22.5368 115.556 23.3688C115.208 24.1884 114.73 24.8962 114.121 25.4923C113.525 26.0759 112.818 26.5354 111.998 26.8707C111.178 27.1935 110.284 27.355 109.316 27.355H109.223ZM109.279 24.7845C109.887 24.7845 110.433 24.6789 110.918 24.4678C111.402 24.2443 111.812 23.9463 112.147 23.5737C112.482 23.2012 112.737 22.7728 112.911 22.2885C113.085 21.7918 113.172 21.264 113.172 20.7052V20.5934C113.172 20.0098 113.078 19.4758 112.892 18.9915C112.718 18.4948 112.464 18.0664 112.128 17.7063C111.806 17.3462 111.402 17.0668 110.918 16.8681C110.446 16.657 109.912 16.5514 109.316 16.5514C108.707 16.5514 108.161 16.657 107.677 16.8681C107.192 17.0792 106.776 17.3648 106.429 17.7249C106.081 18.085 105.814 18.5134 105.628 19.0102C105.441 19.5069 105.348 20.0408 105.348 20.6121V20.7052C105.348 21.264 105.435 21.7918 105.609 22.2885C105.795 22.7852 106.056 23.2198 106.391 23.5923C106.739 23.9525 107.155 24.2443 107.639 24.4678C108.124 24.6789 108.67 24.7845 109.279 24.7845ZM50.5754 14.1299C51.6185 14.1423 52.5437 14.3224 53.3508 14.6701C54.158 15.0178 54.8286 15.4835 55.3625 16.0671C55.9089 16.6383 56.3187 17.3089 56.5919 18.0788C56.8775 18.8363 57.0203 19.6435 57.0203 20.5003V20.6493C57.0203 21.5186 56.8651 22.3444 56.5546 23.1267C56.2442 23.909 55.8034 24.5982 55.2321 25.1943C54.6609 25.7779 53.9779 26.2498 53.1832 26.6099C52.3884 26.9576 51.5068 27.1439 50.5382 27.1687H45.3413V14.1299H50.5754ZM54.1332 20.6307C54.1456 20.047 54.0711 19.5131 53.9096 19.0288C53.7482 18.5321 53.4998 18.1099 53.1646 17.7622C52.8293 17.402 52.4009 17.1226 51.8793 16.924C51.3578 16.7128 50.7493 16.6073 50.0539 16.6073H48.154V24.6913H49.849C50.5568 24.6789 51.1715 24.5672 51.693 24.356C52.227 24.1449 52.6741 23.8655 53.0342 23.5178C53.3943 23.1577 53.6675 22.7417 53.8538 22.2698C54.04 21.7855 54.1332 21.2702 54.1332 20.7238V20.6307ZM62.1604 24.8403H69.5925V27.1687H59.3478V14.1299H69.3876V16.4583H62.1604V19.5131H68.8847V21.7855H62.1604V24.8403ZM80.5202 27.1687H83.7985L79.1046 20.5376L83.5005 14.1299H80.3898L77.4282 18.4327L74.3734 14.1299H71.1323L75.5655 20.4817L72.3855 24.9411L72.378 24.9352L70.4147 27.6776L69.3909 29.1693H72.6622L74.0863 27.1687H74.094L77.2978 22.6051L80.5202 27.1687ZM85.6162 27.1687V14.1299H88.4289V27.1687H85.6162ZM101.623 24.8403H94.2844V14.1299H91.4717V27.1687H101.623V24.8403ZM129.886 14.1299H127.203V22.512L120.907 14.1299H118.411V27.1687H121.075V18.7121L127.39 27.1687H129.886V14.1299Z" fill="#42E8E0"/>
                  <path d="M19.9207 13.7314C20.9638 13.7438 21.8889 13.9239 22.696 14.2716C23.5032 14.6193 24.1738 15.0849 24.7077 15.6686C25.2541 16.2398 25.6639 16.9104 25.9371 17.6803C26.2227 18.4378 26.3655 19.2449 26.3655 20.1018V20.2508C26.3655 21.12 26.2103 21.9458 25.8999 22.7281C25.5894 23.5105 25.1486 24.1996 24.5774 24.7957C24.0061 25.3793 23.3232 25.8512 22.5284 26.2113C21.7337 26.559 20.852 26.7453 19.8834 26.7701H14.6865V13.7314H19.9207ZM23.4784 20.2321C23.4908 19.6485 23.4163 19.1145 23.2549 18.6302C23.0934 18.1335 22.8451 17.7113 22.5098 17.3636C22.1745 17.0035 21.7461 16.7241 21.2245 16.5254C20.703 16.3143 20.0945 16.2087 19.3991 16.2087H17.4992V24.2928H19.1942C19.902 24.2804 20.5167 24.1686 21.0383 23.9575C21.5722 23.7464 22.0193 23.467 22.3794 23.1193C22.7395 22.7592 23.0127 22.3432 23.199 21.8713C23.3852 21.387 23.4784 20.8717 23.4784 20.3253V20.2321Z" fill="#42E8E0"/>
                  <path d="M88.0115 4.77105L88.0555 12.1235L81.3069 7.90642L88.0115 4.77105Z" fill="#42E8E0"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3644 33.5826C26.6459 33.5826 32.5488 27.7239 32.5488 20.4969C32.5488 13.2699 26.6459 7.41122 19.3644 7.41122C12.0828 7.41122 6.17988 13.2699 6.17988 20.4969C6.17988 27.7239 12.0828 33.5826 19.3644 33.5826ZM19.3644 35.7224C27.8366 35.7224 34.7048 28.9057 34.7048 20.4969C34.7048 12.0881 27.8366 5.27142 19.3644 5.27142C10.8921 5.27142 4.02393 12.0881 4.02393 20.4969C4.02393 28.9057 10.8921 35.7224 19.3644 35.7224Z" fill="#42E8E0"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M19.3364 36.9631C28.5146 36.9631 35.9551 29.5785 35.9551 20.469C35.9551 11.3596 28.5146 3.97492 19.3364 3.97492C10.1582 3.97492 2.71776 11.3596 2.71776 20.469C2.71776 29.5785 10.1582 36.9631 19.3364 36.9631ZM19.3364 39.6603C30.0155 39.6603 38.6726 31.0681 38.6726 20.469C38.6726 9.86999 30.0155 1.27777 19.3364 1.27777C8.65734 1.27777 0.000244141 9.86999 0.000244141 20.469C0.000244141 31.0681 8.65734 39.6603 19.3364 39.6603Z" fill="#42E8E0"/>
                </svg>
              </a>
            </div>
            <div class="header-navigation">
              <nav class="header-nav-wrap">
                <ul class="header-nav">
                  <li class="header-nav__item">
                    <router-link
                        :to="'/swaps'"
                        tag="a"
                        class="header-nav__item-link"
                        :class="{'active': subIsActive('/swaps')}"
                        exact
                    >{{ $t('Derivatives') }}</router-link>
                  </li>

                  <li class="header-nav__item">
                    <router-link
                        :to="'/trading-data'"
                        class="header-nav__item-link"
                        :class="{'active': subIsActive('/trading-data')}"
                        exact
                    >
                      {{ $t('Data') }}
                    </router-link>
                  </li>
                  <li class="header-nav__item">
                    <a
                        target="_blank"
                        class="header-nav__item-link"
                        href="https://terminal.dexilon.io/"
                    >
                      {{$t('Terminal')}}
                      <span class="new-text">{{$t('New')}}</span>
                    </a>
                  </li>
<!--                  <li-->
<!--                      class="header-nav__item header-nav__item-dropdown"-->
<!--                      :class="{'current': subIsActive('/trading-data'), active: showSubMenuData}"-->
<!--                      @click="showSubMenuData = !showSubMenuData"-->
<!--                      v-click-outside="() => {showSubMenuData = false}"-->
<!--                  >-->
<!--                    {{$t('data')}}-->
<!--                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path d="M9.22727 0H0.770516C0.0848333 0 -0.258008 0.758914 0.227684 1.20379L3.92751 4.59274C4.52034 5.13575 5.48458 5.13575 6.07741 4.59274L7.48449 3.30389L9.77724 1.20379C10.2558 0.758914 9.91295 0 9.22727 0Z" fill="white"/>-->
<!--                    </svg>-->
<!--                    <div class="sub-menu" v-if="showSubMenuData">-->
<!--                      <div class="sub-menu-wrapper">-->
<!--                        <svg class="sub-menu-wrapper-arrow" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                          <mask id="path-1-inside-1_12753_292500" fill="white">-->
<!--                            <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z"/>-->
<!--                          </mask>-->
<!--                          <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z" fill="#262626"/>-->
<!--                          <path d="M9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L23.3353 10.1066L21.9211 11.5208L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L9.19313 0.207107ZM11.3145 22.1274L0.00074482 10.8137L11.3145 22.1274ZM-0.706362 10.1066L9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L0.707852 11.5208L-0.706362 10.1066ZM22.6282 10.8137L11.3145 22.1274L22.6282 10.8137Z" fill="#1E1E1E" mask="url(#path-1-inside-1_12753_292500)"/>-->
<!--                        </svg>-->
<!--                        <div class="sub-menu-category">-->
<!--                          <ul class="sub-menu-list">-->
<!--                            <li class="header-nav__item">-->
<!--                              <router-link-->
<!--                                  :to="'/trading-data'"-->
<!--                                  tag="a"-->
<!--                                  class="header-nav__item-link"-->
<!--                                  :class="{'active': subIsActive('/trading-data')}"-->
<!--                                  exact-->
<!--                              >-->
<!--                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                  <path d="M3 22H21M5.6 8.38H4C3.45 8.38 3 8.83 3 9.38V18C3 18.55 3.45 19 4 19H5.6C6.15 19 6.6 18.55 6.6 18V9.38C6.6 8.83 6.15 8.38 5.6 8.38ZM12.8 5.19H11.2C10.65 5.19 10.2 5.64 10.2 6.19V18C10.2 18.55 10.65 19 11.2 19H12.8C13.35 19 13.8 18.55 13.8 18V6.19C13.8 5.64 13.35 5.19 12.8 5.19ZM20 2H18.4C17.85 2 17.4 2.45 17.4 3V18C17.4 18.55 17.85 19 18.4 19H20C20.55 19 21 18.55 21 18V3C21 2.45 20.55 2 20 2Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                </svg>-->
<!--                                <div class="header-nav__item-content">-->
<!--                                  <span class="header-nav__item-title">{{ $t('Trading Data') }}</span>-->
<!--                                  <span class="header-nav__item-description">{{ $t('Internal market analytics') }}</span>-->
<!--                                </div>-->
<!--                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                </svg>-->
<!--                              </router-link>-->
<!--                            </li>-->
<!--                            <li class="header-nav__item">-->
<!--                              &lt;!&ndash; href="https://terminal.dexilon.io/"&ndash;&gt;-->
<!--                              <a-->
<!--                                  target="_blank"-->
<!--                                  class="header-nav__item-link"-->
<!--                                  href="https://terminal.dexilon.io/"-->
<!--                              >-->
<!--                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                  <path d="M4.02001 5.97C2.70624 7.70547 1.99677 9.82334 2.00001 12C2.00001 17.52 6.48001 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                  <path d="M5 12C5 15.87 8.13 19 12 19C15.87 19 19 15.87 19 12C19 8.13 15.87 5 12 5" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                  <path d="M12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                </svg>-->
<!--                                <div class="header-nav__item-content">-->
<!--                                  <span class="header-nav__item-title">-->
<!--                                    {{$t('Dexilon Terminal')}}-->
<!--&lt;!&ndash;                                    <span class="disabled-text">{{$t('Coming Soon')}}</span>&ndash;&gt;-->
<!--                                  </span>-->
<!--                                  <span class="header-nav__item-description">{{$t('Extetrnal market analytics')}}</span>-->
<!--                                </div>-->
<!--                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                                </svg>-->
<!--                              </a>-->
<!--                            </li>-->
<!--                          </ul>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </li>-->
                  <li class="header-nav__item">
                    <router-link
                        to="/liquidation-auction"
                        class="header-nav__item-link"
                        :class="{'active': subIsActive('/liquidation-auction')}"
                        exact
                    >
                      {{ $t('Liquidation Auction') }}
                    </router-link>
                  </li>
                  <!--                    <li class="header-nav__item">-->
                  <!--                      <router-link-->
                  <!--                          :to="'/legal-privacy'"-->
                  <!--                          tag="a"-->
                  <!--                          class="header-nav__item-link"-->
                  <!--                          :class="{'active': subIsActive('/legal-privacy')}"-->
                  <!--                          exact-->
                  <!--                      >{{$t('LegalPrivacy')}}</router-link>-->
                  <!--                    </li>-->
                  <li
                      class="header-nav__item header-nav__item-dropdown"
                      :class="{'current': subIsActive('/rewards/'), active: showSubMenuReward}"
                      @click="showSubMenuReward = !showSubMenuReward"
                      v-click-outside="() => {showSubMenuReward = false}"
                  >
                    {{$t('Rewards')}}
                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.22727 0H0.770516C0.0848333 0 -0.258008 0.758914 0.227684 1.20379L3.92751 4.59274C4.52034 5.13575 5.48458 5.13575 6.07741 4.59274L7.48449 3.30389L9.77724 1.20379C10.2558 0.758914 9.91295 0 9.22727 0Z" fill="white"/>
                    </svg>
                    <div class="sub-menu" v-if="showSubMenuReward">
                      <div class="sub-menu-wrapper">
                        <svg class="sub-menu-wrapper-arrow" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="path-1-inside-1_12753_292500" fill="white">
                            <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z"/>
                          </mask>
                          <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z" fill="#262626"/>
                          <path d="M9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L23.3353 10.1066L21.9211 11.5208L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L9.19313 0.207107ZM11.3145 22.1274L0.00074482 10.8137L11.3145 22.1274ZM-0.706362 10.1066L9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L0.707852 11.5208L-0.706362 10.1066ZM22.6282 10.8137L11.3145 22.1274L22.6282 10.8137Z" fill="#1E1E1E" mask="url(#path-1-inside-1_12753_292500)"/>
                        </svg>
                        <div class="sub-menu-category">
                          <ul class="sub-menu-list">
                            <li class="header-nav__item">
                              <router-link
                                  :to="'/rewards/rounds-of-rewards'"
                                  tag="a"
                                  class="header-nav__item-link"
                                  :class="{'active': subIsActive('/rewards/rounds-of-rewards')}"
                                  exact
                              >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.7309 3.51001L15.4909 7.03001C15.7309 7.52002 16.3709 7.99001 16.9109 8.08001L20.1009 8.61001C22.1409 8.95001 22.6209 10.43 21.1509 11.89L18.6709 14.37C18.2509 14.79 18.0209 15.6 18.1509 16.18L18.8609 19.25C19.4209 21.68 18.1309 22.62 15.9809 21.35L12.9909 19.58C12.4509 19.26 11.5609 19.26 11.0109 19.58L8.02089 21.35C5.88089 22.62 4.58089 21.67 5.14089 19.25L5.85089 16.18C5.98089 15.6 5.75089 14.79 5.33089 14.37L2.85089 11.89C1.39089 10.43 1.86089 8.95001 3.90089 8.61001L7.09089 8.08001C7.62089 7.99001 8.26089 7.52002 8.50089 7.03001L10.2609 3.51001C11.2209 1.60001 12.7809 1.60001 13.7309 3.51001Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{ $t('Rewards') }}</span>
                                  <span class="header-nav__item-description">{{ $t('Current Distribution Round') }}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </router-link>
                            </li>
                            <li class="header-nav__item">
                              <router-link
                                  :to="'/rewards/referral-program'"
                                  tag="a"
                                  class="header-nav__item-link"
                                  :class="{'active': subIsActive('/rewards/referral-program')}"
                                  exact
                              >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M3.41016 22C3.41016 18.13 7.26016 15 12.0002 15C12.9602 15 13.8902 15.13 14.7602 15.37M12.0002 12C13.3262 12 14.598 11.4732 15.5357 10.5355C16.4734 9.59785 17.0002 8.32608 17.0002 7C17.0002 5.67392 16.4734 4.40215 15.5357 3.46447C14.598 2.52678 13.3262 2 12.0002 2C10.6741 2 9.4023 2.52678 8.46462 3.46447C7.52694 4.40215 7.00016 5.67392 7.00016 7C7.00016 8.32608 7.52694 9.59785 8.46462 10.5355C9.4023 11.4732 10.6741 12 12.0002 12Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M19.49 17.98H16.51M18 16.52V19.51M22 18C22 18.32 21.96 18.63 21.88 18.93C21.79 19.33 21.63 19.72 21.42 20.06C21.0675 20.6525 20.5667 21.143 19.967 21.4831C19.3674 21.8233 18.6894 22.0014 18 22C17.0155 22.0029 16.0659 21.6352 15.34 20.97C15.04 20.71 14.78 20.4 14.58 20.06C14.1993 19.4404 13.9985 18.7272 14 18C13.9994 17.4745 14.1024 16.9541 14.3031 16.4685C14.5039 15.9829 14.7985 15.5417 15.1701 15.1701C15.5417 14.7985 15.9829 14.5039 16.4685 14.3031C16.9541 14.1024 17.4745 13.9993 18 14C19.18 14 20.25 14.51 20.97 15.33C21.61 16.04 22 16.98 22 18Z" stroke="#2DCAC2" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{$t('Referral Program')}}</span>
                                  <span class="header-nav__item-description">{{$t('Invite Friends & Get Rewards')}}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </router-link>
                            </li>
                          </ul>
                        </div>
                        <div class="sub-menu-category">
                          <ul class="sub-menu-list" >
                            <li class="header-nav__item">
                              <a
                                  class="header-nav__item-link"
                                  @click="showLeaderboard"
                              >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12.1504 16.5V18.6" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M7.15039 22H17.1504V21C17.1504 19.9 16.2504 19 15.1504 19H9.15039C8.05039 19 7.15039 19.9 7.15039 21V22Z" stroke="#2DCAC2" stroke-width="1.5" stroke-miterlimit="10"/>
                                  <path d="M6.15 22H18.15M12 16C8.13 16 5 12.87 5 9V6C5 3.79 6.79 2 9 2H15C17.21 2 19 3.79 19 6V9C19 12.87 15.87 16 12 16Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M5.46906 11.65C4.71906 11.41 4.05906 10.97 3.53906 10.45C2.63906 9.44998 2.03906 8.24998 2.03906 6.84998C2.03906 5.44998 3.13906 4.34998 4.53906 4.34998H5.18906C4.98906 4.80998 4.88906 5.31998 4.88906 5.84998V8.84998C4.88906 9.84998 5.09906 10.79 5.46906 11.65ZM18.5291 11.65C19.2791 11.41 19.9391 10.97 20.4591 10.45C21.3591 9.44998 21.9591 8.24998 21.9591 6.84998C21.9591 5.44998 20.8591 4.34998 19.4591 4.34998H18.8091C19.0091 4.80998 19.1091 5.31998 19.1091 5.84998V8.84998C19.1091 9.84998 18.8991 10.79 18.5291 11.65Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{ $t('Tournaments') }}</span>
                                  <span class="header-nav__item-description">{{$t('Traders Competition')}}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </a>
                            </li>
                            <li class="header-nav__item">
                              <router-link
                                  :to="'/rewards/rewards-history'"
                                  tag="a"
                                  class="header-nav__item-link"
                                  :class="{'active': subIsActive('/rewards/rewards-history')}"
                                  exact
                              >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.5 10.22V19C19.5 21 19 22 16.5 22H7.5C5 22 4.5 21 4.5 19V10.22M10.18 14H13.82M5 2H19C21 2 22 3 22 5V7C22 9 21 10 19 10H5C3 10 2 9 2 7V5C2 3 3 2 5 2Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{ $t('Rewards History') }}</span>
                                  <span class="header-nav__item-description">{{ $t('Rounds’ Distribution Acrhive') }}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </router-link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                      class="header-nav__item header-nav__item-dropdown"
                      :class="{'current': subIsActive('/info/'), active: showSubMenuInfo}"
                      @click="showSubMenuInfo = !showSubMenuInfo"
                      v-click-outside="() => {showSubMenuInfo = false}"
                  >
                    {{$t('Info')}}
                    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.22727 0H0.770516C0.0848333 0 -0.258008 0.758914 0.227684 1.20379L3.92751 4.59274C4.52034 5.13575 5.48458 5.13575 6.07741 4.59274L7.48449 3.30389L9.77724 1.20379C10.2558 0.758914 9.91295 0 9.22727 0Z" fill="white"/>
                    </svg>
                    <div class="sub-menu" v-if="showSubMenuInfo">
                      <div class="sub-menu-wrapper">
                        <svg class="sub-menu-wrapper-arrow" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="path-1-inside-1_12753_292500" fill="white">
                            <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z"/>
                          </mask>
                          <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z" fill="#262626"/>
                          <path d="M9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L23.3353 10.1066L21.9211 11.5208L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L9.19313 0.207107ZM11.3145 22.1274L0.00074482 10.8137L11.3145 22.1274ZM-0.706362 10.1066L9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L0.707852 11.5208L-0.706362 10.1066ZM22.6282 10.8137L11.3145 22.1274L22.6282 10.8137Z" fill="#1E1E1E" mask="url(#path-1-inside-1_12753_292500)"/>
                        </svg>
                        <div class="sub-menu-category">
                          <div class="sub-menu-header">{{$t('General Info')}}</div>
                          <ul class="sub-menu-list">
                            <li class="header-nav__item">
                              <a href="https://dexilon.gitbook.io/dexilon-knowledge-base/" class="header-nav__item-link" target="_blank">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z" stroke="#02C9BF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5M8 13H12M8 17H16" stroke="#02C9BF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{ $t('Documentation') }}</span>
                                  <span class="header-nav__item-description">{{ $t('Overview of Dexilon') }}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </a>
                            </li>
                            <li class="header-nav__item">
                              <router-link
                                  :to="'/info/fees'"
                                  tag="a"
                                  class="header-nav__item-link"
                                  :class="{'active': subIsActive('/info/fees')}"
                                  exact
                              >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8.57 15.27L15.11 8.73M9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2Z" stroke="#02C9BF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M8.98 10.37C9.30622 10.37 9.61907 10.2404 9.84974 10.0097C10.0804 9.77908 10.21 9.46622 10.21 9.14C10.21 8.81379 10.0804 8.50093 9.84974 8.27026C9.61907 8.03959 9.30622 7.91 8.98 7.91C8.65378 7.91 8.34093 8.03959 8.11026 8.27026C7.87959 8.50093 7.75 8.81379 7.75 9.14C7.75 9.46622 7.87959 9.77908 8.11026 10.0097C8.34093 10.2404 8.65378 10.37 8.98 10.37ZM15.52 16.09C15.8462 16.09 16.1591 15.9604 16.3897 15.7297C16.6204 15.4991 16.75 15.1862 16.75 14.86C16.75 14.5338 16.6204 14.2209 16.3897 13.9903C16.1591 13.7596 15.8462 13.63 15.52 13.63C15.1938 13.63 14.8809 13.7596 14.6503 13.9903C14.4196 14.2209 14.29 14.5338 14.29 14.86C14.29 15.1862 14.4196 15.4991 14.6503 15.7297C14.8809 15.9604 15.1938 16.09 15.52 16.09Z" stroke="#02C9BF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{ $t('Fees') }}</span>
                                  <span class="header-nav__item-description">{{$t('Fees & Incentives')}}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </router-link>
                            </li>
                            <li class="header-nav__item">
                              <router-link
                                  :to="'/info/faq'"
                                  tag="a"
                                  class="header-nav__item-link"
                                  :class="{'active': subIsActive('/info/faq')}"
                                  exact
                              >
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M17 18.43H13L8.55 21.39C8.39982 21.4901 8.22528 21.5476 8.045 21.5563C7.86472 21.5649 7.68546 21.5245 7.52635 21.4393C7.36724 21.3541 7.23424 21.2273 7.14154 21.0725C7.04884 20.9176 6.99992 20.7405 7 20.56V18.43C4 18.43 2 16.43 2 13.43V7.42999C2 4.42999 4 2.42999 7 2.42999H17C20 2.42999 22 4.42999 22 7.42999V13.43C22 16.43 20 18.43 17 18.43Z" stroke="#02C9BF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M11.9998 11.36V11.15C11.9998 10.47 12.4198 10.11 12.8398 9.81998C13.2498 9.53998 13.6598 9.17999 13.6598 8.51999C13.6598 7.59999 12.9198 6.85999 11.9998 6.85999C11.0798 6.85999 10.3398 7.59999 10.3398 8.51999M11.9948 13.75H12.0048" stroke="#02C9BF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{$t('FAQ')}}</span>
                                  <span class="header-nav__item-description">{{$t('Frequently asked questions')}}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </router-link>
                            </li>
                          </ul>
                        </div>
                        <div class="sub-menu-category">
                          <div class="sub-menu-header">{{$t('Automatic Trading')}}</div>
                          <ul class="sub-menu-list" >
                            <li class="header-nav__item">
                              <a href="https://github.com/dexilon-exchange" class="header-nav__item-link" target="_blank">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <g clip-path="url(#clip0_12916_295489)">
                                    <path d="M6.1391 18.4606C5.82986 18.2568 5.56392 17.997 5.25262 17.6292C5.09104 17.4337 4.93092 17.2371 4.77227 17.0393C4.29502 16.4534 3.99403 16.1834 3.68273 16.0723C3.42534 15.981 3.2152 15.7923 3.09853 15.5478C2.98187 15.3033 2.96824 15.023 3.06065 14.7686C3.15305 14.5142 3.34391 14.3065 3.59126 14.1912C3.8386 14.0759 4.12215 14.0624 4.37954 14.1537C5.1547 14.4288 6.35172 15.7576 6.35172 15.7576C6.35172 15.7576 6.73696 16.2068 6.83282 16.3209C7.02867 16.5522 7.17298 16.6928 7.28637 16.7672C7.49665 16.9068 7.89144 16.9669 8.47178 16.9099C8.49549 16.5206 8.56867 16.1426 8.68 15.7942C5.62061 15.0544 3.88888 13.1042 3.88888 9.27724C3.88888 8.0138 4.27028 6.8767 4.97946 5.92301C4.75475 5.01211 4.78876 3.91067 5.29076 2.67066C5.34773 2.5304 5.43556 2.40441 5.54788 2.30185C5.6602 2.19928 5.79419 2.1227 5.94016 2.07766C6.02365 2.05321 6.07107 2.042 6.15456 2.02977C6.98229 1.90445 8.1512 2.20299 9.67471 3.14649C10.5826 2.93668 11.512 2.83138 12.4444 2.83267C13.3845 2.83267 14.3184 2.93864 15.2111 3.14649C16.7336 2.19585 17.9045 1.89732 18.7385 2.02977C18.8261 2.04302 18.9003 2.06034 18.9632 2.08072C19.1063 2.12736 19.2373 2.20445 19.347 2.30655C19.4567 2.40865 19.5424 2.53329 19.5981 2.67168C20.1001 3.91067 20.1341 5.01211 19.9094 5.92199C20.6217 6.87568 21 8.00565 21 9.27724C21 13.1053 19.2745 15.0493 16.2151 15.7901C16.3439 16.2129 16.4109 16.6857 16.4109 17.1962C16.411 18.1186 16.4069 19.0411 16.3986 19.9635C16.63 20.0134 16.8371 20.1406 16.9848 20.3238C17.1325 20.5069 17.2119 20.7347 17.2096 20.9689C17.2073 21.2031 17.1235 21.4293 16.9722 21.6096C16.8209 21.7898 16.6114 21.9131 16.379 21.9585C15.2049 22.1908 14.3349 21.4165 14.3349 20.4047L14.337 19.9503L14.3421 19.2319C14.3473 18.5106 14.3493 17.8686 14.3493 17.1962C14.3493 16.486 14.1607 16.0224 13.9113 15.8105C13.2299 15.2297 13.5752 14.1242 14.4679 14.0253C17.5262 13.686 18.9384 12.5153 18.9384 9.27724C18.9384 8.30419 18.6168 7.50027 17.9973 6.82779C17.8668 6.68641 17.7792 6.51155 17.7446 6.32324C17.7099 6.13493 17.7296 5.94078 17.8015 5.76304C17.9726 5.34121 18.0458 4.78795 17.9004 4.11853L17.8901 4.12158C17.384 4.26321 16.7459 4.5699 15.9749 5.08852C15.8506 5.17193 15.7093 5.22745 15.561 5.25121C15.4127 5.27497 15.2609 5.26639 15.1163 5.22608C14.2462 4.98794 13.3473 4.86831 12.4444 4.87048C11.527 4.87048 10.6179 4.99173 9.77264 5.22709C9.62855 5.26709 9.47738 5.2756 9.32964 5.25202C9.18189 5.22844 9.04111 5.17335 8.91708 5.09056C8.14193 4.57398 7.50077 4.26831 6.99156 4.12566C6.84313 4.791 6.91632 5.34223 7.0864 5.76304C7.15835 5.94069 7.17824 6.13478 7.14379 6.32309C7.10933 6.5114 7.02193 6.68631 6.89158 6.82779C6.27619 7.49416 5.95046 8.31336 5.95046 9.27724C5.95046 12.5092 7.36368 13.6871 10.4055 14.0253C11.2972 14.1242 11.6435 15.2246 10.9663 15.8064C10.7684 15.9776 10.5241 16.5522 10.5241 17.1962V20.4057C10.5241 21.4104 9.66337 22.1633 8.50373 21.9626C8.26847 21.9218 8.05486 21.8014 7.8994 21.6222C7.74394 21.4429 7.65628 21.2159 7.65142 20.9798C7.64655 20.7438 7.72477 20.5134 7.8727 20.328C8.02064 20.1426 8.22912 20.0138 8.4625 19.9635V18.9548C7.52448 19.0169 6.74933 18.8651 6.1391 18.4606Z" fill="#2DCAC2"/>
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_12916_295489">
                                      <rect width="24" height="24" fill="white"/>
                                    </clipPath>
                                  </defs>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{ $t('GitHub') }}</span>
                                  <span class="header-nav__item-description">{{ $t('Source Code') }}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </a>
                            </li>
                            <li class="header-nav__item">
                              <a href="https://dexilon.gitbook.io/dexilon-api-documentation" class="header-nav__item-link" target="_blank">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.9994 21.41H5.93944C2.46944 21.41 1.01944 18.93 2.69944 15.9L5.81944 10.28L8.75944 5C10.5394 1.79 13.4594 1.79 15.2394 5L18.1794 10.29L21.2994 15.91C22.9794 18.94 21.5194 21.42 18.0594 21.42H11.9994V21.41Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M21.4405 20L12.0005 13.39M12.0005 13.39L2.56055 20M12.0005 13.39V3" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{ $t('API') }}</span>
                                  <span class="header-nav__item-description">{{$t('API Documentation')}}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </a>
                            </li>
                            <li class="header-nav__item">
                              <a href="http://status.dexilon.io/" class="header-nav__item-link" target="_blank">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6.88086 18.15V16.08M12.0009 18.15V14.01M17.1209 18.15V11.93M17.1209 5.85001L16.6609 6.39001C14.1078 9.37082 10.6894 11.482 6.88086 12.43" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round"/>
                                  <path d="M14.1895 5.85001H17.1195V8.77001" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                  <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div class="header-nav__item-content">
                                  <span class="header-nav__item-title">{{$t('Status Page')}}</span>
                                  <span class="header-nav__item-description">{{$t('Real-time system status updates')}}</span>
                                </div>
                                <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
<!--                  <li class="header-nav__item">-->
<!--                    <a-->
<!--                        class="header-nav__item-link leaderboard"-->
<!--                        @click="showLeaderboard"-->
<!--                    >-->
<!--                      <span class="header-emoji">🏆</span>-->
<!--                      {{ $t('Leaderboard') }}-->
<!--                    </a>-->
<!--                  </li>-->
                </ul>
              </nav>
            </div>
            <div class="header-content">
<!--              <div v-if="getBinanceWallet.networkName && !getBinanceWallet.disconected" class="holder-network">-->
<!--                <span class="holder-network-title textSecondaryColor">{{ $t('network') }}</span>-->
<!--                <span class="holder-network-currency textMainColor">{{getBinanceWallet.networkName}}</span>-->
<!--              </div>-->
<!--              <div v-if="getMetamaskWallet.networkName && !getMetamaskWallet.disconected" class="holder-network">-->
<!--                <span class="holder-network-title textSecondaryColor">{{ $t('network') }}</span>-->
<!--                <span class="holder-network-currency textMainColor">{{getMetamaskWallet.networkName}}</span>-->
<!--              </div>-->
              <a class="user-settings" @click="$router.push('/reports/transaction-history?page=1&type=FUTURE').catch(() => {})" v-if="token">
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.00078 9.00002C9.10585 9.00002 10.1657 8.56103 10.9471 7.77963C11.7285 6.99823 12.1674 5.93842 12.1674 4.83335C12.1674 3.72829 11.7285 2.66848 10.9471 1.88708C10.1657 1.10567 9.10585 0.666687 8.00078 0.666687C6.89571 0.666687 5.83591 1.10567 5.0545 1.88708C4.2731 2.66848 3.83411 3.72829 3.83411 4.83335C3.83411 5.93842 4.2731 6.99823 5.0545 7.77963C5.83591 8.56103 6.89571 9.00002 8.00078 9.00002ZM8.00078 11.0834C3.82578 11.0834 0.425781 13.8834 0.425781 17.3334C0.425781 17.5667 0.609115 17.75 0.842448 17.75H15.1591C15.3924 17.75 15.5758 17.5667 15.5758 17.3334C15.5758 13.8834 12.1758 11.0834 8.00078 11.0834Z" fill="#E9E9E9"/>
                </svg>
                {{$t('Account')}}
              </a>
              <div class="button-wrapper">
                <!-- <button @click="openPopup" class="order-form-callateral-button" v-if="!haveWalletProvider || ((!getMetamaskWallet.address || getMetamaskWallet.disconected) && !binanceWallet.address)">{{ $t('connectWallet') }}</button> -->
                <button @click="openPopup" class="order-form-callateral-button" v-if="Boolean(!token)">
                  <svg v-if="!connectWalletText" width="24" height="100%" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 399.97 399.97" style="enable-background:new 0 0 399.97 399.97;" xml:space="preserve">
                  <path d="M387.109,30.338c-8.301-8.289-19.328-12.853-31.049-12.853H77.7c-4.142,0-7.5,3.358-7.5,7.5v30.5H48.102 c-4.142,0-7.5,3.358-7.5,7.5v27.32H23.67c-4.142,0-7.5,3.358-7.5,7.5v87.089H7.5c-4.142,0-7.5,3.358-7.5,7.5v88 c0,4.142,3.358,7.5,7.5,7.5h8.67v87.091c0,4.142,3.358,7.5,7.5,7.5h332.39c24.212,0,43.91-19.698,43.91-43.91V61.394 C399.97,49.66,395.404,38.632,387.109,30.338z M15,272.894v-73h42.5c20.126,0,36.5,16.374,36.5,36.5 c0,20.126-16.374,36.5-36.5,36.5H15z M384.97,338.574c0,15.941-12.969,28.91-28.91,28.91H31.17v-79.591H57.5 c28.397,0,51.5-23.103,51.5-51.5c0-28.397-23.103-51.5-51.5-51.5H31.17v-79.589h324.89c11.065,0,21.18-4.123,28.91-10.902 V338.574z M361,89.873V62.984c0-4.142-3.358-7.5-7.5-7.5h-29.621c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5H346 v19.819H55.602V70.484h214.68c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H85.2v-23h270.86 c7.719,0,14.982,3.007,20.447,8.463c5.458,5.458,8.463,12.719,8.463,20.447C384.97,75.65,374.594,87.521,361,89.873z" />
                    <path d="M59.32,242.62c-0.096-0.065-0.178-0.12,0.018,0.013c0.19,0.128,0.106,0.071,0.01,0.006 c5.206,3.5,12.389-0.944,11.589-7.162c-0.771-5.992-8.429-8.821-12.739-4.384c-2.897,2.814-2.896,7.786,0,10.6 C58.533,242.038,58.917,242.343,59.32,242.62z" />
                    <path d="M302.988,57.573c-4.663-4.527-12.831-1.287-12.81,5.31c0.02,6.578,8.133,9.843,12.81,5.3 c2.081-2.143,2.797-5.389,1.62-8.17C304.232,59.102,303.674,58.28,302.988,57.573z" />
                    <path d="M304.608,60.013C304.798,60.463,304.418,59.553,304.608,60.013L304.608,60.013z" />
                </svg>
                  {{ connectWalletText ? $t('connectWallet') : '' }}
                </button>
                <div
                    v-if="Boolean(token)"
                    class="login-button marketHeaderButton"
                    :class="isDropdownDisconnect ? 'open' : 'close'"
                    @click="dropdownDisconnect"
                    v-click-outside="closeDropdownDisconnect"
                >
                  <div class="login-button-img-wrap">
                    <img src="@/assets/img/walleticontest.svg" alt="user image" class="login-button-img">
                  </div>
                  <div class="login-button-info" v-if="Boolean(token)">
                    <span v-if="getMetamaskWallet.address" class="login-button-info-title textSecondaryColor">{{modifyAddress(getMetamaskWallet.address)}}</span>
<!--                    <span class="login-button-info-price" v-if="Boolean(token)">-->
<!--                        <span class="login-button-info-price-value textMainColor">{{ getMetamaskWallet.convertedBalance || 0 }}</span>-->
<!--                        <span class="login-button-info-currency">MATIC</span>-->
<!--                      </span>-->
                  </div>
                  <svg :style="isDropdownDisconnect ? 'transform: rotate( -180deg )' : ''" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.22727 0H0.770516C0.0848333 0 -0.258008 0.758914 0.227684 1.20379L3.92751 4.59274C4.52034 5.13575 5.48458 5.13575 6.07741 4.59274L7.48449 3.30389L9.77724 1.20379C10.2558 0.758914 9.91295 0 9.22727 0Z" fill="white"/>
                  </svg>
                </div>

                <div v-if="getBinanceWallet.address && !!token" class="login-button marketHeaderButton" @click="dropdownDisconnect" >
                  <div class="login-button-img-wrap">
                    <img src="@/assets/img/binance.svg" alt="user image" class="login-button-img">
                  </div>
                  <div class="login-button-info">
                    <span v-if="getBinanceWallet.address && !!token" class="login-button-info-title textSecondaryColor">{{modifyAddress(getBinanceWallet.address)}}</span>
                    <span class="login-button-info-price">
                        <span class="login-button-info-price-value textMainColor">{{ getBinanceWallet.convertedBalance || 0 }}</span>
                        <span class="login-button-info-currency">MATIC</span>
                      </span>
                  </div>
                  <svg :style="isDropdownDisconnect ? 'transform: rotate( -180deg )' : ''" width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.22727 0H0.770516C0.0848333 0 -0.258008 0.758914 0.227684 1.20379L3.92751 4.59274C4.52034 5.13575 5.48458 5.13575 6.07741 4.59274L7.48449 3.30389L9.77724 1.20379C10.2558 0.758914 9.91295 0 9.22727 0Z" fill="white"/>
                  </svg>
                </div>
                <div v-if="isDropdownDisconnect" class="holder-dropdown wallet-holder-dropdown">
                  <svg class="sub-menu-wrapper-arrow" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="path-1-inside-1_12753_292500" fill="white">
                      <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z"/>
                    </mask>
                    <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z" fill="#262626"/>
                    <path d="M9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L23.3353 10.1066L21.9211 11.5208L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L9.19313 0.207107ZM11.3145 22.1274L0.00074482 10.8137L11.3145 22.1274ZM-0.706362 10.1066L9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L0.707852 11.5208L-0.706362 10.1066ZM22.6282 10.8137L11.3145 22.1274L22.6282 10.8137Z" fill="#1E1E1E" mask="url(#path-1-inside-1_12753_292500)"/>
                  </svg>
                  <div class="wallet-sub-menu-header">
                    <div class="wallet-sub-menu-cosmos-wrap">
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.1372 8.5C12.7624 8.50762 13.3169 8.6181 13.8006 8.83143C14.2844 9.04476 14.6863 9.33048 15.0064 9.68857C15.3339 10.039 15.5795 10.4505 15.7432 10.9229C15.9144 11.3876 16 11.8829 16 12.4086V12.5C16 13.0333 15.907 13.54 15.7209 14.02C15.5348 14.5 15.2706 14.9229 14.9282 15.2886C14.5859 15.6467 14.1765 15.9362 13.7002 16.1571C13.2238 16.3705 12.6954 16.4848 12.1148 16.5H9V8.5H12.1372ZM14.2695 12.4886C14.277 12.1305 14.2323 11.8029 14.1356 11.5057C14.0388 11.201 13.89 10.9419 13.689 10.7286C13.488 10.5076 13.2313 10.3362 12.9187 10.2143C12.6061 10.0848 12.2414 10.02 11.8246 10.02H10.6858V14.98H11.7018C12.126 14.9724 12.4944 14.9038 12.807 14.7743C13.1271 14.6448 13.395 14.4733 13.6108 14.26C13.8267 14.039 13.9904 13.7838 14.1021 13.4943C14.2137 13.1971 14.2695 12.881 14.2695 12.5457V12.4886Z" fill="#42E8E0"/>
                        <circle cx="12" cy="12.5" r="10.25" stroke="#42E8E0" stroke-width="1.5"/>
                        <circle cx="12" cy="12.5" r="8.4" stroke="#42E8E0" stroke-width="1.2"/>
                      </svg>
                      <div class="wallet-sub-menu-cosmos-info">
                        <span class="wallet-sub-menu-cosmos-address">{{modifyAddress(cosmosWallet)}}</span>
                        <span class="wallet-sub-menu-cosmos-balance">0.00 DXLN</span>
                      </div>
                    </div>
                    <div class="wallet-sub-menu-cosmos-network">Dexilon Network</div>
                  </div>
                  <div class="sub-menu-category">
                    <div class="sub-menu-header">{{$t('Personal Account')}}</div>
                    <ul class="sub-menu-list" >
                      <li class="header-nav__item">
                        <router-link
                            :to="'/reports/transaction-history?page=1&type=FUTURE'"
                            tag="a"
                            class="header-nav__item-link"
                            :class="{'active': subIsActive('/reports/transaction-history?page=1&type=FUTURE')}"
                            exact
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z" stroke="#2DCAC2" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5M8 13H12M8 17H16" stroke="#2DCAC2" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <div class="header-nav__item-content">
                            <span class="header-nav__item-title">{{ $t('Reports') }}</span>
                            <span class="header-nav__item-description">{{$t('Your activity history')}}</span>
                          </div>
                          <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </router-link>
                      </li>
                      <li class="header-nav__item">
                        <router-link
                            :to="'/reports/open-orders'"
                            tag="a"
                            class="header-nav__item-link"
                            :class="{'active': subIsActive('/reports/open-orders')}"
                            exact
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19 15.75H18M6 15.75H5M18 7.75V14.5C18 13.4 17.1 12.5 16 12.5H8C6.9 12.5 6 13.4 6 14.5V7.75C6 6.65 6.9 5.75 8 5.75H16C17.1 5.75 18 6.65 18 7.75Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 14V11C18 9.9 17.1 9 16 9H8C6.9 9 6 9.9 6 11V14" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M18 14.5V15.75H14.5C14.5 16.413 14.2366 17.0489 13.7678 17.5178C13.2989 17.9866 12.663 18.25 12 18.25C11.337 18.25 10.7011 17.9866 10.2322 17.5178C9.76339 17.0489 9.5 16.413 9.5 15.75H6V14.5C6 13.4 6.9 12.5 8 12.5H16C17.1 12.5 18 13.4 18 14.5Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <div class="header-nav__item-content">
                            <span class="header-nav__item-title">{{ $t('Open Orders') }}</span>
                            <span class="header-nav__item-description">{{$t('The list of Open Orders')}}</span>
                          </div>
                          <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </router-link>
                      </li>
                      <li class="header-nav__item">
                        <router-link
                            :to="'/rewards/referral-program'"
                            tag="a"
                            class="header-nav__item-link"
                            :class="{'active': subIsActive('/rewards/referral-program')}"
                            exact
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.40625 22C3.40625 18.13 7.25625 15 11.9963 15C12.9563 15 13.8863 15.13 14.7563 15.37M11.9963 12C13.3223 12 14.5941 11.4732 15.5318 10.5355C16.4695 9.59785 16.9963 8.32608 16.9963 7C16.9963 5.67392 16.4695 4.40215 15.5318 3.46447C14.5941 2.52678 13.3223 2 11.9963 2C10.6702 2 9.3984 2.52678 8.46072 3.46447C7.52303 4.40215 6.99625 5.67392 6.99625 7C6.99625 8.32608 7.52303 9.59785 8.46072 10.5355C9.3984 11.4732 10.6702 12 11.9963 12Z" stroke="#2DCAC2" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.49 17.98H16.51M18 16.52V19.51M22 18C22 18.32 21.96 18.63 21.88 18.93C21.79 19.33 21.63 19.72 21.42 20.06C21.0675 20.6525 20.5667 21.143 19.967 21.4831C19.3674 21.8233 18.6894 22.0014 18 22C17.0155 22.0029 16.0659 21.6352 15.34 20.97C15.04 20.71 14.78 20.4 14.58 20.06C14.1993 19.4404 13.9985 18.7272 14 18C13.9994 17.4745 14.1024 16.9541 14.3031 16.4685C14.5039 15.9829 14.7985 15.5417 15.1701 15.1701C15.5417 14.7985 15.9829 14.5039 16.4685 14.3031C16.9541 14.1024 17.4745 13.9993 18 14C19.18 14 20.25 14.51 20.97 15.33C21.61 16.04 22 16.98 22 18Z" stroke="#2DCAC2" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <div class="header-nav__item-content">
                            <span class="header-nav__item-title">{{ $t('Referral Program') }}</span>
                            <span class="header-nav__item-description">{{$t('Invite friends and get rewards')}}</span>
                          </div>
                          <svg class="header-nav__item-arrow" width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L5 5L1 9" stroke="#92939C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </router-link>
                      </li>
                    </ul>
                  </div>
                  <ul class="holder-dropdown-disconnect">
                    <li
                        class="holder-dropdown-item"
                        @click="disconectWallet"
                    >
                      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.1 6.56001C13.79 2.96001 11.94 1.49001 7.89 1.49001H7.76C3.29 1.49001 1.5 3.28001 1.5 7.75001V14.27C1.5 18.74 3.29 20.53 7.76 20.53H7.89C11.91 20.53 13.76 19.08 14.09 15.54M8 11H19.38M17.15 7.65001L20.5 11L17.15 14.35" stroke="#F27870" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="header-nav__item-content">
                        <span class="header-nav__item-title">{{$t('Logout')}}</span>
                        <span class="header-nav__item-description">{{$t('Disconnect Wallet')}}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

<!--              -->

<!--              <div class="lang-switcher">-->
<!--                <div class="lang-switcher-header" @click="openLocale" :class="{open: openLocaleDropdown}" v-click-outside="closeLangList">-->
<!--                  <span class="lang-switcher-current-lang" v-text="this.currentLocale" v-if="!languageText"></span>-->
<!--                  <svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" style="margin-right: 5px" v-else>-->
<!--                    <path d="M20.1338 4.87957L19.8047 4.98391L18.0519 5.14007L17.5568 5.93069L17.1975 5.81654L15.8026 4.55884L15.6002 3.90478L15.3292 3.2073L14.4524 2.42089L13.4181 2.21851L13.3943 2.6919L14.4076 3.68069L14.9034 4.26472L14.346 4.55604L13.8922 4.42229L13.2122 4.13867L13.2353 3.59035L12.3432 3.22341L12.047 4.51262L11.1478 4.7164L11.2367 5.43559L12.4083 5.66108L12.6107 4.51192L13.5778 4.65478L14.0274 4.91809H14.7486L15.2423 5.90688L16.5512 7.23461L16.4552 7.75072L15.3999 7.61626L13.5764 8.53713L12.2633 10.1121L12.0925 10.8095H11.6212L10.743 10.4048L9.8901 10.8095L10.1023 11.7094L10.4734 11.2815L11.1261 11.2612L11.0806 12.0693L11.6212 12.2276L12.1611 12.8341L13.0428 12.5862L14.0498 12.7451L15.2192 13.0595L15.8033 13.1282L16.7935 14.2521L18.7045 15.3761L17.4685 17.7374L16.1639 18.3439L15.6688 19.6933L13.7809 20.9538L13.5799 21.6807C18.4062 20.5182 21.9965 16.1828 21.9965 10.9993C21.9951 8.73531 21.3089 6.62817 20.1338 4.87957Z" fill="var(&#45;&#45;v-textMainColor-base)"/>-->
<!--                    <path d="M12.2626 16.7486L11.4615 15.2633L12.1968 13.7311L11.4615 13.5112L10.6359 12.6821L8.80672 12.2717L8.19958 11.0014V11.7556H7.93207L6.35574 9.61834V7.86274L5.20028 5.98388L3.36555 6.31091H2.12955L1.5077 5.90335L2.30112 5.2745L1.5098 5.45727C0.556022 7.08612 0 8.97618 0 11.0007C0 17.0742 4.92367 22 10.9979 22C11.4657 22 11.9244 21.9587 12.3782 21.9041L12.2633 20.5714C12.2633 20.5714 12.7682 18.5924 12.7682 18.5252C12.7675 18.4573 12.2626 16.7486 12.2626 16.7486Z" fill="var(&#45;&#45;v-textMainColor-base)"/>-->
<!--                    <path d="M4.08685 3.54692L6.04063 3.27451L6.94119 2.78081L7.9545 3.07283L9.57355 2.98319L10.1282 2.11134L10.937 2.2444L12.9013 2.06022L13.4426 1.46359L14.2059 0.953781L15.2857 1.11625L15.6793 1.05672C14.257 0.387255 12.6744 0 10.9972 0C7.58335 0 4.53083 1.55602 2.51542 3.9993H2.52102L4.08685 3.54692ZM11.4622 1.09384L12.5855 0.47549L13.3067 0.892157L12.2626 1.68697L11.2654 1.78711L10.8165 1.4958L11.4622 1.09384ZM8.13517 1.18417L8.63097 1.39076L9.28013 1.18417L9.63377 1.79692L8.13517 2.19048L7.41458 1.76891C7.41458 1.76891 8.11906 1.31513 8.13517 1.18417Z" fill="var(&#45;&#45;v-textMainColor-base)"/>-->
<!--                  </svg>-->
<!--                  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                    <path d="M1.6665 1.33333L6.99984 6.66667L12.3332 1.33333" stroke="#42E8E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                  </svg>-->
<!--                </div>-->
<!--                <div class="lang-switcher-dropdown" v-if="openLocaleDropdown">-->
<!--                  <div class="lang-switcher-dropdown-item"-->
<!--                       v-for="(lang, i) in langs"-->
<!--                       :key="`Lang${i}`"-->
<!--                       @click="changeLocale(lang)"-->
<!--                       :class="{ active: lang === $i18n.locale}"-->
<!--                  >-->
<!--                    {{ lang === 'ru' ? 'Русский' : lang === 'en' ? 'English' : lang === 'es' ? 'Español' : lang === 'hi'  ? 'Hindi' : lang === 'zh' ? 'Chinese ' : ''}}-->
<!--                    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--                      <path d="M0.75 4.74038L4.425 8.375L11.25 1.625" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--                    </svg>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              -->

              <a class="language-settings lang-switcher" @click="openLocale" :class="{open: openLocaleDropdown}" v-click-outside="closeLangList">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.73675 14.6825C4.71425 14.6825 4.68425 14.6975 4.66175 14.6975C3.20675 13.9775 2.02175 12.785 1.29425 11.33C1.29425 11.3075 1.30925 11.2775 1.30925 11.255C2.22425 11.525 3.16925 11.7275 4.10675 11.885C4.27175 12.83 4.46675 13.7675 4.73675 14.6825ZM14.705 11.3375C13.9625 12.83 12.725 14.0375 11.2175 14.765C11.5025 13.8125 11.7425 12.8525 11.9 11.885C12.845 11.7275 13.775 11.525 14.69 11.255C14.6825 11.285 14.705 11.315 14.705 11.3375ZM14.765 4.7825C13.82 4.4975 12.8675 4.265 11.9 4.1C11.7425 3.1325 11.51 2.1725 11.2175 1.235C12.77 1.9775 14.0225 3.23 14.765 4.7825ZM4.7375 1.31675C4.4675 2.23175 4.2725 3.16175 4.115 4.10675C3.1475 4.25675 2.1875 4.49675 1.235 4.78175C1.9625 3.27425 3.17 2.03675 4.6625 1.29425C4.685 1.29425 4.715 1.31675 4.7375 1.31675ZM10.619 3.9425C8.879 3.7475 7.124 3.7475 5.384 3.9425C5.5715 2.915 5.8115 1.8875 6.149 0.8975C6.164 0.8375 6.1565 0.7925 6.164 0.7325C6.7565 0.59 7.364 0.5 8.0015 0.5C8.6315 0.5 9.2465 0.59 9.8315 0.7325C9.839 0.7925 9.839 0.8375 9.854 0.8975C10.1915 1.895 10.4315 2.915 10.619 3.9425ZM3.9425 10.619C2.9075 10.4315 1.8875 10.1915 0.8975 9.854C0.8375 9.839 0.7925 9.8465 0.7325 9.839C0.59 9.2465 0.5 8.639 0.5 8.0015C0.5 7.3715 0.59 6.7565 0.7325 6.1715C0.7925 6.164 0.8375 6.164 0.8975 6.149C1.895 5.819 2.9075 5.5715 3.9425 5.384C3.755 7.124 3.755 8.879 3.9425 10.619ZM15.5 8.0015C15.5 8.639 15.41 9.2465 15.2675 9.839C15.2075 9.8465 15.1625 9.839 15.1025 9.854C14.105 10.184 13.085 10.4315 12.0575 10.619C12.2525 8.879 12.2525 7.124 12.0575 5.384C13.085 5.5715 14.1125 5.8115 15.1025 6.149C15.1625 6.164 15.2075 6.1715 15.2675 6.1715C15.41 6.764 15.5 7.3715 15.5 8.0015ZM10.619 12.0575C10.4315 13.0925 10.1915 14.1125 9.854 15.1025C9.839 15.1625 9.839 15.2075 9.8315 15.2675C9.2465 15.41 8.6315 15.5 8.0015 15.5C7.364 15.5 6.7565 15.41 6.164 15.2675C6.1565 15.2075 6.164 15.1625 6.149 15.1025C5.82286 14.1067 5.56723 13.0892 5.384 12.0575C6.254 12.155 7.124 12.2225 8.0015 12.2225C8.879 12.2225 9.7565 12.155 10.619 12.0575ZM10.8222 10.8222C8.94819 11.0589 7.05181 11.0589 5.17775 10.8222C4.94112 8.94819 4.94112 7.05181 5.17775 5.17775C7.05181 4.94112 8.94819 4.94112 10.8222 5.17775C11.0589 7.05181 11.0589 8.94819 10.8222 10.8222Z" fill="#E9E9E9"/>
                </svg>
                <div class="sub-menu sub-menu-lang" v-if="openLocaleDropdown">
                  <div class="sub-menu-wrapper">
                    <svg class="sub-menu-wrapper-arrow" width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <mask id="path-1-inside-1_12753_292500" fill="white">
                        <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z"/>
                      </mask>
                      <path d="M9.90024 0.914214C10.6813 0.133165 11.9476 0.133165 12.7287 0.914214L22.6282 10.8137L11.3145 22.1274L0.00074482 10.8137L9.90024 0.914214Z" fill="#262626"/>
                      <path d="M9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L23.3353 10.1066L21.9211 11.5208L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L9.19313 0.207107ZM11.3145 22.1274L0.00074482 10.8137L11.3145 22.1274ZM-0.706362 10.1066L9.19313 0.207107C10.3647 -0.964466 12.2642 -0.964466 13.4358 0.207107L12.0216 1.62132C11.631 1.2308 10.9979 1.2308 10.6073 1.62132L0.707852 11.5208L-0.706362 10.1066ZM22.6282 10.8137L11.3145 22.1274L22.6282 10.8137Z" fill="#1E1E1E" mask="url(#path-1-inside-1_12753_292500)"/>
                    </svg>
                    <div class="sub-menu-category">
                      <ul class="sub-menu-list">
                        <li
                            class="header-nav__item"
                            v-for="(lang, i) in langs"
                            :key="`Lang${i}`"
                        >
                          <a class="header-nav__item-link"
                             @click="changeLocale(lang)"
                             :class="{ select: lang === $i18n.locale}"
                          >
                            <div class="header-nav__item-content">
                              <span class="header-nav__item-title">{{ lang === 'ru' ? 'Русский' : lang === 'en' ? 'English, USA' : lang === 'es' ? 'Español' : lang === 'hi'  ? 'हिन्दी' : lang === 'zh' ? '西班牙語 ' : ''}}</span>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </a>

              <SettingDropdown />
              <Slide :closeOnNavigation="true" right push width="300" v-if="device === 'mobile'">
                <ul class="header-nav mobile">
                  <li class="header-nav__item">
                    <router-link
                        :to="{ name: 'Trading' }"
                        tag="a"
                        class="header-nav__item-link"
                        exact
                    >{{ $t('Derivatives') }}</router-link>
                  </li>
                  <li class="header-nav__item">
                    <router-link
                        :to="'/trading-data'"
                        tag="a"
                        class="header-nav__item-link"
                        :class="{'active': subIsActive('/trading-data')}"
                        exact
                    >{{ $t('data') }}</router-link>
                  </li>
                  <!--                <li class="header-nav__item">-->
                  <!--                  <router-link-->
                  <!--                      :to="'/legal-privacy'"-->
                  <!--                      tag="a"-->
                  <!--                      class="header-nav__item-link"-->
                  <!--                      :class="{'active': subIsActive('/legal-privacy')}"-->
                  <!--                      exact-->
                  <!--                  >{{$t('LegalPrivacy')}}</router-link>-->
                  <!--                </li>-->
                  <li class="header-nav__item">
                    <router-link
                        :to="'/information'"
                        tag="a"
                        class="header-nav__item-link"
                        :class="{'active': subIsActive('/information')}"
                        exact
                    >
                      {{$t('Info')}}
                    </router-link>
                  </li>
                  <li class="header-nav__item">
                    <router-link
                        :to="'/legal-privacy/faq'"
                        tag="a"
                        class="header-nav__item-link"
                        :class="{'active': subIsActive('/legal-privacy/faq')}"
                        exact
                    >
                      {{$t('FAQ')}}
                    </router-link>
                  </li>
                  <li class="header-nav__item">
                    <router-link
                        :to="'/knowledge-base'"
                        tag="a"
                        class="header-nav__item-link"
                        :class="{'active': subIsActive('/knowledge-base')}"
                        exact
                    >
                      {{ $t('knowledgeBase') }}
                    </router-link>
                  </li>
                </ul>
              </Slide>
              <!--                <v-switch-->
              <!--                    v-model="theme"-->
              <!--                    @change="$emit('changeTheme')"-->
              <!--                    class="language-switcher"-->
              <!--                ></v-switch>-->
            </div>
          </div>
        </div>
      </header>
    </v-theme-provider>
    <ServiceMessage
        ref="walletErrorPopup"
        :errorMessageTitle="$store.state.wallets.metaMaskWallet.errorTitle"
        :errorText="$store.state.wallets.metaMaskWallet.error"
        @onConfirm="clearErrorText"
    />
    <ConnectWallet
        ref="connectWallet"
        @connect="connectWallet"
    />
    <div class="pending-transition-alert" v-if="isHasMoneyContract">
      <div class="pending-transition-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.5 9.5V14.5M12 14.5C12.663 14.5 13.2989 14.2366 13.7678 13.7678C14.2366 13.2989 14.5 12.663 14.5 12C14.5 11.337 14.2366 10.7011 13.7678 10.2322C13.2989 9.76339 12.663 9.5 12 9.5C11.337 9.5 10.7011 9.76339 10.2322 10.2322C9.76339 10.7011 9.5 11.337 9.5 12C9.5 12.663 9.76339 13.2989 10.2322 13.7678C10.7011 14.2366 11.337 14.5 12 14.5ZM5 22C6.06087 22 7.07828 21.5786 7.82843 20.8284C8.57857 20.0783 9 19.0609 9 18C9 16.9391 8.57857 15.9217 7.82843 15.1716C7.07828 14.4214 6.06087 14 5 14C3.93913 14 2.92172 14.4214 2.17157 15.1716C1.42143 15.9217 1 16.9391 1 18C1 19.0609 1.42143 20.0783 2.17157 20.8284C2.92172 21.5786 3.93913 22 5 22Z" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.25 16.75V17.68C5.25 18.03 5.07 18.36 4.76 18.54L4 19" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 15.2V9C2 5.5 4 4 7 4H17C20 4 22 5.5 22 9V15C22 18.5 20 20 17 20H8.5" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="pending-transition-content">
        <span class="pending-transition-title">{{$t('Pending Transition')}}</span>
        <p class="pending-transition-descr">
          {{$t('There are funds left in your profile that have not yet completed the withdrawal:')}}
          <a @click="popupWithdraw">Complete</a>
        </p>
      </div>
    </div>
    <leaderboard-popup
        ref="leaderboardPopup"
        :token="token"
    />
    <CommonDialogWithdraw
        ref="commonDialogWithdraw"
        :title="$t('Pending Withdrawal')"
        :popupClass="'withdraw-popup'"
        @closePopup="closeWithdrawPopup"
    >
      <div class="popup-order-descr">
        {{ $t('There are funds left in your profile that have not yet completed the withdrawal.') }}
      </div>

      <div class="withdraw-popup-body">
        <div class="withdraw-popup-content">
          <div class="withdraw-popup-amount">
            <img :src="currencyIcon" alt="coin logo">
            <span class="withdraw-popup-amount-value">{{withdrawValue}}</span>
            <span class="secondary-text"> USDT</span>
          </div>
          <div class="withdraw-popup-info-description">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.20868 5.19649C7.20868 4.82968 7.55615 4.51114 8.00019 4.51114C8.43455 4.51114 8.78211 4.82968 8.78211 5.19649C8.78211 5.56333 8.43458 5.89152 8.00019 5.89152C7.55618 5.89152 7.20868 5.56333 7.20868 5.19649ZM7.25686 7.23327C7.25686 6.963 7.56575 6.77955 8.00013 6.77955C8.41522 6.77955 8.75304 6.96297 8.75304 7.23322V10.911C8.75304 11.1427 8.41522 11.3743 8.00013 11.3743C7.56575 11.3743 7.25686 11.1427 7.25686 10.911V7.23327Z" fill="#92939C"/>
              <circle cx="8" cy="8" r="7" stroke="#92939C" stroke-width="1.5"/>
            </svg>
            <p> {{ $t('To receive funds, please, complete operation by signing the request in Metamask.') }}</p>
          </div>
        </div>
      </div>
      <template>
        <div class="notification-btn-wrapper">
          <button
              class="notification-btn notification-btn-confirm"
              @click="commonWithdrawAction"
              :disabled="+withdrawValue === 0 || isDisableButton"
          >
            <div
                class="spinner rounded-circle"
                v-if="isDisableButton"
            >
            </div>
            <span v-if="isDisableButton">{{$t('Waiting for signing...')}}</span>
            <span v-else>{{$t('Confirm')}}</span>
          </button>
        </div>
      </template>
    </CommonDialogWithdraw>
    <Connect
        ref="connectWalletPopup"
        :authData="authData"
    />
  </div>
</template>

<style lang="css">
@import '../../assets/css/fonts.css';
</style>

<script>
import CommonDialogWithdraw from '../popups/CommonDialogWithdraw.vue';
import LeaderboardPopup from "@/components/popups/Leaderboard.vue";
import { getFromLocalStorage } from '../../helpers';
import { mapActions, mapGetters } from 'vuex';
import { Trans } from '@/plugins/translation';
import { Slide } from 'vue-burger-menu'
import {wsPrivate} from "@/utils/socketPrivate";
import TradingInputPricePopup from "../inputs/TradingInputPricePopup";
import Web3 from 'web3';
const Web3Utils = require('web3-utils');
import HDWalletProvider from "@truffle/hdwallet-provider";
import {useReactiveMap} from "vue-reactive-collection";
import ToasterMetamask from "@/components/toasters/ToasterMetamask";
import ToasterSuccess from "@/components/toasters/ToasterSuccess.vue";
import ToasterError from "@/components/toasters/ToasterError.vue";
import LottieAnimation from 'lottie-web-vue'
import store from "@/store";
import Connect from "@/components/popups/Connect.vue";

if (window.web3) { // Legacy dapp browsers...
  window.web3 = new Web3(web3.currentProvider);
} else { // Non-dapp browsers...
  console.log('Non-Ethereum browser detected. You should consider trying MetaMask!');
}

window.dataLayer = window.dataLayer || [];

let withdrawPopup = null
export default {
  name: "Header",
  components: {
    Connect,
    CommonDialogWithdraw,
    LeaderboardPopup,
    LottieAnimation,
    ConnectWallet: () => import("../popups/ConnectWallet"),
    ServiceMessage: () => import("../popups/ServiceMessage"),
    SettingDropdown: () => import("../settings-dropdown/SettingsDropdown"),
    Slide,
    // TradingInputPricePopup,
    // ServiceMessage
  },
  props: {
    symbol: Object,
  },
  data() {
    return {
      authData: null,
      isClaimToken: JSON.parse(localStorage.getItem('isClaimToken')),
      showPreloader: false,
      contractAddress: process.env.VUE_APP_CONTRACT,
      contractABI: JSON.parse(process.env.VUE_APP_CONTRACT_ABI),
      contractAddressUsdt: process.env.VUE_APP_CONTRACT_STABLE,
      theme: this.$vuetify.theme.dark ? false : true,
      submitted: false,
      showPopupDeposit: '',
      userPhoto: JSON.parse(localStorage.getItem('headerPhoto')),
      headerFirstName: JSON.parse(localStorage.getItem('headerFirstName')),
      isPageLogin: Boolean,
      menuIsOpen: false,
      notifications: null,
      isLogged: null,
      showSubMenuInfo: false,
      showSubMenuReward: false,
      showSubMenuData: false,
      langs: ['en', 'ru', 'es', 'hi', 'zh'],
      currentLocale: this.$i18n.locale === 'ru'
          ? 'Русский' : this.$i18n.locale === 'en'
              ? 'English' : this.$i18n.locale === 'es'
                  ? 'Español' : this.$i18n.locale === 'hi'
                      ? 'Hindi' : this.$i18n.locale === 'zh'
                          ? 'Chinese ' : '',
      switchLocale: '',
      openLocaleDropdown: false,
      isDropdownDisconnect: false,
      device: null,
      windowWidth: null,
      dexLogoShort: false,
      languageText: true,
      connectWalletText: false,
      token: null,
      isDisableButton: false,
      isHasMoneyContract: null,
      withdrawValue: 0,
      currencyIcon: require('@/assets/img/coin/usdt.svg'),
    }
  },
  computed: {

    cosmosWallet() {
      return this.$store.state.wallets.metaMaskWallet.authData ? this.$store.state.wallets.metaMaskWallet.authData.granterWallet.address : ''
    },

    walletAddress() {
      return this.$store.getters["wallets/getMetamaskWallet"].address
    },

    statusPreloader() {
      return this.$store.state.wallets.preloader
    },

    supportedLocales () {
      return Trans.supportedLocales
    },

    haveWalletProvider() {
      return !!window.ethereum || !!window.BinanceChain;
    },

    networkId() {
      return window.ethereum.networkVersion
    },

    metamaskWalletDisconected() {
      return !this.getMetamaskWallet.address || this.getMetamaskWallet.disconected;
    },

    binanceWalletDisconected() {
      return !this.getBinanceWallet.address || this.getBinanceWallet.disconected;
    },

    walletError() {
      return this.$store.state.wallets.metaMaskWallet.error
    },

    ...mapGetters('wallets', ['getMetamaskWallet', 'getBinanceWallet']),
  },
  created() {
    window.addEventListener("resize", this.checkScreenWidth);
  },
  watch: {
    token: {
      deep: true,
      handler(newValue, oldValue) {
        const cosmosAddress = JSON.parse(localStorage.getItem('cosmosAddress'))
        if(newValue) {
          if(cosmosAddress) {
            if(wsPrivate.wsPrivate === null ||  wsPrivate.wsPrivate !== null && wsPrivate.wsPrivate.readyState === 3) {
              setTimeout(() => {
                wsPrivate.initWebSocket(newValue.replaceAll('"', ''), cosmosAddress)
                // this.$emit('subscribe');
                this.l2UpdateSubscribe();
              }, 200)
            }
          }
          const isClaimToken = localStorage.getItem('isClaimToken');
          if(isClaimToken === null) {
            this.checkDepositEntry().then((res) => {
              if (res.check) {
                this.isClaimToken = true
                localStorage.setItem('isClaimToken', true)
              } else {
                this.isClaimToken = false
                localStorage.removeItem('isClaimToken')
              }
            })
          }
        }else {
          wsPrivate.evt.removeAllListeners()
          wsPrivate.close()
        }
      }
    },
    'getMetamaskWallet.address'(newVal, oldValue) {
      if(newVal) {
        this.checkConnectedWallets();
        if(this.token) {
          this.connectWallet();
        }
        // this.beforeAuth(newVal);
        return;
      }
    },
    isHasMoneyContract(newVal) {
      // alert(newVal)
    },
    windowWidth(newVal) {
      this.$emit('windowWidth', newVal)
    },
    walletError(newVal, oldVal) {
      if(newVal !== null) {
        setTimeout(() => {
          this.$refs.walletErrorPopup.openPopups()
        },500)
      }
    }
  },
  methods: {
    ...mapActions({
      metamaskRequest: 'wallets/metamaskRequest',
      setMetamaskDisconect: 'wallets/metamaskConnection',
      subscribeToMetaMaskEvent: 'wallets/subscribeToMetaMaskEvent',
      binanceRequest: 'wallets/binanceRequest',
      setBinanceDisconect: 'wallets/binanceConnection',
      subscribeToBinanceEvent: 'wallets/subscribeToBinanceEvent',
      checkDepositEntry: 'markets/checkDepositEntry',
      setDepositEntry: 'markets/setDepositEntry',
      getMarketsTrades: 'markets/getMarketsTrades',
      beforeAuth: 'wallets/beforeAuth',
    }),
    async beforeAuth(wallet) {
      const dataWallets = {
        ethWallet: wallet,
      }
      this.$store.commit('wallets/CHANGE_PRELOAD_STATUS', true)
      await this.$store.dispatch('wallets/beforeAuth', dataWallets).then((data) => {
        this.authData = data

        if(this.authData.type === 'login') {
          this.$refs.connectWalletPopup.open('login');
        }else {
          this.$refs.connectWalletPopup.open('register');
        }
      })
    },

    connectWallet() {
      // this.$refs.connectWalletPopup.open();
      if(this.getMetamaskWallet && this.getMetamaskWallet.address) {
        this.beforeAuth(this.getMetamaskWallet.address)
      }
    },

    closeDropdownDisconnect() {
      this.isDropdownDisconnect = false
    },
    closeLangList() {
      this.openLocaleDropdown = false
    },
    clearErrorText() {
      this.$store.commit('wallets/METAMASK_ERROR', null);
    },
    checkScreenWidth(e) {
      let width = e.currentTarget.innerWidth
      if (width >= 1101) {
        this.device = 'desktop'
      } else if (width <= 1100) {
        this.device = 'mobile'
      }
      width <= 700 ? this.dexLogoShort = true : this.dexLogoShort = false
      width <= 500 ? this.connectWalletText = false : this.connectWalletText = true
      width <= 380 ? this.languageText = true : this.languageText = false

    },
    checkConnectedWallets() {
      const metaMaskAccount = getFromLocalStorage('metamask');
      const binanceAccount = getFromLocalStorage('binance');
      const token = getFromLocalStorage('token');

      if (token) {
        if (metaMaskAccount && !metaMaskAccount.disconected) {
          this.metamaskRequest({method: 'eth_requestAccounts'});
          this.subscribeToMetaMaskEvent('chainNetwork');
        }
      }

      if (binanceAccount) {
        this.setBinanceDisconect(binanceAccount.disconected);
        if (!binanceAccount.disconected) {
          this.binanceRequest({method: 'eth_accounts'});
        }
      }
    },

    modifyAddress(str) {
      return `${str.substring(0,9)}...${str.slice(str.length - 4)}`;
    },

    disconectWallet() {
      const metaMaskAccount = getFromLocalStorage('metamask');
      this.setMetamaskDisconect(true);
      this.setBinanceDisconect(true);
      this.closeDropdownDisconnect();

      if(metaMaskAccount && metaMaskAccount.address) {
        window.dataLayer.push({
          event: 'authentication',
          action: 'user-log-out',
          userId: metaMaskAccount.address
        });
      }

      localStorage.removeItem('metamask')
      localStorage.removeItem('token')
      window.dispatchEvent(new CustomEvent('token-localstorage-remove'));
      localStorage.removeItem('isHasMoneyContract')
      window.dispatchEvent(new CustomEvent('isHasMoneyContract-localstorage-remove'));
      localStorage.removeItem('isClaimToken')
    },

    openPopup () {
      this.$refs.connectWallet.openPopups();
    },

    onChangeValue(event) {
      return event.target.value
    },
    changeLocale (lang) {
      // this.$i18n.locale = lang
      if (this.$i18n.locale !== lang) {
        // const to = this.$router.resolve({ params: {lang} })
        return Trans.changeLocale(lang).then(() => {
          this.currentLocale = lang === 'ru' ? 'Русский' : lang === 'en' ? 'English' : lang === 'es' ? 'Español' : lang === 'hi'  ? 'Hindi' : lang === 'zh' ? 'Chinese ' : ''
          localStorage.setItem('lang', lang)
        })
      }
    },
    openLocale() {
      this.openLocaleDropdown = !this.openLocaleDropdown
    },
    onChangequoteCurrency(event) {
      return event.target.options[event.target.selectedIndex].dataset.quoteCurrency
    },
    onChangebaseCurrency(event) {
      return event.target.options[event.target.selectedIndex].dataset.baseCurrency
    },
    // changeLocale () {
    //   this.$vuetify.lang.current = this.switchLocale
    // },
    handleSubmitLogout () {
      this.submitted = true;
      const { dispatch } = this.$store;
      dispatch('authentication/logout');
      clearInterval(this.$store.state.intervals.amountInterval)
    },
    openMenu () {
      this.menuIsOpen = true
    },
    dropdownDisconnect () {
      this.isDropdownDisconnect = !this.isDropdownDisconnect;
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0 // current path starts with this path string
      })
    },

    convertHistoryValue(str) {
      const newStr =  `ethereumbridge.${str.replace('l2Spot', '')}Event`
      return newStr
    },

    updateHistory(historyMap, res) {
      if(historyMap.value.has(res.transactionUuid)) {
        historyMap.value.set(res.transactionUuid, {
          ...historyMap.value.get(res.transactionUuid),
          status: this.convertHistoryValue(res.eventType)
        })
        this.$store.commit('reports/SET_TRANSACTION_HISTORY', historyMap.value)
      }
    },

    l2UpdateSubscribe() {
      wsPrivate.subscribe(
          `l2Update`,
          {
            method: "SUBSCRIBE",
            params: ['l2Update']
          },
          (res) => {

            const metaMaskAccount = getFromLocalStorage('metamask');

            let history = this.$store.getters["reports/getTransactionHistory"];

            let historyMap = useReactiveMap([...history]);

            if (res.eventType === 'l2SpotDeposit') {
              // console.log('l2SpotDeposit', res)
              this.showToasterSuccess(
                  this.$t('Funds Transferred To Spot'),
                  this.$t('Your funds have been transferred to the Spot Account'),
              );
              window.dataLayer.push({
                event: 'money_transaction',
                action: 'deposit',
                to: "spot_account",
                amount: res.amount,
                token: res.asset,
                fee: 0
              });
            }
            if (res.eventType === 'l2SpotTransfer') {
              // console.log('l2SpotTransfer', res)

              if(res.amount > 0) {
                this.showToasterSuccess(
                    this.$t('Funds Transferred To Spot'),
                    this.$t('Your funds have been transferred to the Spot Account'),
                );

                window.dataLayer.push({
                  event: 'money_transaction',
                  action: 'transfer',
                  to: "spot_account",
                  amount: res.amount,
                  token: res.asset,
                  fee: 0
                });
              }

              if(res.amount < 0) {
                this.showToasterSuccess(
                    this.$t('Funds Transferred From Spot'),
                    this.$t('Your funds have been transferred from the Spot Account, in a few seconds they will appear in the Future Account'),
                );

                window.dataLayer.push({
                  event: 'money_transaction',
                  action: 'transfer',
                  to: "futures_account",
                  amount: res.amount,
                  token: res.asset,
                  fee: 0
                });
              }
            }
            if (res.eventType === 'l2SpotWithdrawBatchReadyToBridge') {
              // console.log('l2SpotWithdrawBatchReadyToBridge', res)
              this.updateHistory(historyMap, res);
            }
            if (res.eventType === 'l2SpotWithdrawSetInBatch') {
              // console.log('l2SpotWithdrawSetInBatch', res)
              this.updateHistory(historyMap, res);
              this.showToasterSuccess(
                  this.$t('Funds Withdrawn From Spot'),
                  this.$t('Your funds have been withdrawn from Spot Account, you can check the Spot Transaction History.'),
              );
            }
            if (res.eventType === 'l2SpotWithdrawSignBatch') {
              // console.log('l2SpotWithdrawSignBatch', res)
              this.updateHistory(historyMap, res);
            }
            if (res.eventType === 'l2SpotWithdrawFinalize') {
              console.log('l2SpotWithdrawFinalize', res)
              this.withdrawFinalize();
              this.updateHistory(historyMap, res);
            }

            if(res.balance !== undefined) {
              this.$store.commit('wallets/SET_SPOT_BALANCE_USDT', res.balance * 1000000000000000000)
            }
          }
      );
    },

    withdrawFinalize() {
      this.withdrawValue = 0
      const retry = async () => {
        const contractAddress = this.contractAddress
        const contractABI = this.contractABI
        const contract = new window.web3.eth.Contract(contractABI, contractAddress)
        const result = await contract.methods.getAvailableBalance(this.contractAddressUsdt, this.walletAddress).call({from: this.walletAddress})
        if (+result === 0) {
          setTimeout(() => {
            retry();
          }, 1000)
        } else {
          localStorage.setItem('isHasMoneyContract', true)
          this.withdrawValue = (+result / 1000000).toFixed(2);
          this.updateWithdrawLocalStoradge();
          withdrawPopup.openPopups();
        }
      };
      retry();
    },

    commonWithdrawAction() {
      let contractAddress = this.contractAddress
      let contractABI = this.contractABI
      let contract = new window.web3.eth.Contract(contractABI, contractAddress)

      this.isDisableButton = true;

      this.showToasterMetamask(
          this.$t('New Signature Request'),
          this.$t('Check MetaMask for a new Signature Request'),
      );


      contract.methods.withdraw(this.contractAddressUsdt).send({
        from: this.walletAddress,
        gas: 1300000,
        data: contractAddress,
      }, () => {
      }).then(() => {
        this.isDisableButton = false;
        this.$refs.commonDialogWithdraw.closePopups();
        localStorage.removeItem('isHasMoneyContract')
        window.dispatchEvent(new CustomEvent('isHasMoneyContract-localstorage-remove'));
        // this.popupTitle = this.$t('Withdraw')
        // this.$refs.commonDialogOrderSuccess.openPopups();
      }).catch(error => {
        if(error.code) {
          this.isDisableButton = false;
        }
        if(error.code !== 4001) {
          this.$store.commit('wallets/METAMASK_ERROR', error.message)
        }
      })
    },

    closeWithdrawPopup() {
      // localStorage.setItem('isHasMoneyContract', true)
      this.updateWithdrawLocalStoradge();
    },

    updateWithdrawLocalStoradge() {
      window.dispatchEvent(new CustomEvent('isHasMoneyContract-localstorage-changed', {
        detail: {
          isHasMoneyContract: localStorage.getItem('isHasMoneyContract')
        }
      }));
    },

    checkUserBalanceContract() {
      const contractAddress = this.contractAddress
      const contractABI = this.contractABI
      const contract = new window.web3.eth.Contract(contractABI, contractAddress)
      console.log('contractAddress', contractAddress)
      console.log('contractABI', contractABI)
      console.log('contract', contract)
      contract.methods.getAvailableBalance(this.contractAddressUsdt, this.walletAddress).call({from: this.walletAddress}, (error, result) => {
        console.log('result', result)
        console.log('error', error)
        if((+result / 1000000) > 0) {
          localStorage.setItem('isHasMoneyContract', true)
          this.withdrawValue = (result / 1000000).toFixed(2);
          // this.popupWithdraw();
          this.updateWithdrawLocalStoradge();
        }
      });
    },

    popupWithdraw() {
      this.checkUserBalanceContract();
      withdrawPopup.openPopups();
      // this.$refs.commonDialogWithdraw.openPopups();
    },

    closePopup() {
      this.isDisableButton = false;
      this.$refs.commonDialogWithdraw.closePopups();
    },

    showToasterMetamask(title, description) {
      this.$toast.success({
        component: ToasterMetamask,
        props:  {
          title,
          description,
        },
      });
    },
    showToasterSuccess(title, description) {
      this.$toast.success({
        component: ToasterSuccess,
        props:  {
          title,
          description,
        },
      });
    },

    showToasterError(title, description) {
      this.$toast.error({
        component: ToasterError,
        props:  {
          title,
          description,
        },
      });
    },
    showLeaderboard() {
      this.$refs.leaderboardPopup.showDialog()
    },

    sendTransactionMatic() {
      const mnemonic = "science edit same around chat hero swear shy industry eagle brush energy";
      const provider = new HDWalletProvider({
        mnemonic: {
          phrase: mnemonic
        },
        providerOrUrl: process.env.VUE_APP_WALLET_PROVIDER,
        pollingInterval: 8000
      });
      const web3 = new Web3(provider);
      const fromAddress = '0xaEC766463922244a091fcb7B8f11045839eeeb3D'
      const toAddress = this.walletAddress
      const tx1 = {
        from: fromAddress,
        to: toAddress,
        gas: 70000,
        value: web3.utils.toWei('0.10', 'ether'),
      };

      const signPromiseMatic = web3.eth.signTransaction(tx1, tx1.from);
      signPromiseMatic.then((signedTx) => {
        this.showPreloader = true
        const sentTx = web3.eth.sendSignedTransaction(signedTx.raw || signedTx.rawTransaction);
        sentTx.on("receipt", receipt => {
        });
        sentTx.on("error", err => {
          this.showPreloader = false
          this.showToasterError(
              this.$t('Claim USDT Error'),
              this.$t(`${err.message}`),
          );
        });
        sentTx.then(() => {
          provider.engine.stop()
          this.sendTransactionUSDC()
        })
      }).catch((err) => {
        provider.engine.stop()
        this.showPreloader = false
        this.showToasterError(
            this.$t('Claim USDT Error'),
            this.$t(`${err.message}`),
        );
      });

    },

    sendTransactionUSDC() {
      const mnemonic = "science edit same around chat hero swear shy industry eagle brush energy";
      const provider = new HDWalletProvider({
        mnemonic: {
          phrase: mnemonic
        },
        providerOrUrl: process.env.VUE_APP_WALLET_PROVIDER,
        pollingInterval: 8000
      });
      const web3 = new Web3(provider);
      const fromAddress = '0xaEC766463922244a091fcb7B8f11045839eeeb3D'
      const toAddress = this.walletAddress
      const tokenABI = JSON.parse(process.env.VUE_APP_CONTRACT_STABLE_ABI)
      const tokenAddress = process.env.VUE_APP_CONTRACT_STABLE;
      const contractInstance = new web3.eth.Contract(tokenABI, tokenAddress);
      const amount = 100000000000;
      const tx2 = {
        from: fromAddress,
        to: contractInstance._address,
        'gasPrice': web3.utils.toHex(60 * 1e9),
        'gasLimit': web3.utils.toHex(600000),
        'value': 0x0,
        data: contractInstance.methods.transfer(toAddress, amount.toString()).encodeABI(),
      }

      web3.eth.getTransactionCount(fromAddress)
          .then((res) => {
            let rawTransaction = {
              'from': fromAddress,
              'gasPrice': web3.utils.toHex(20 * 1e9),
              'gasLimit': web3.utils.toHex(210000),
              'to': contractInstance._address,
              'value': 0x0,
              'data': contractInstance.methods.transfer(toAddress, amount.toString()).encodeABI(),
              'nonce': web3.utils.toHex(res)
            }
            const signPromiseUsdc = web3.eth.signTransaction(tx2, tx2.from)

            signPromiseUsdc.then((signedTx) => {
              const sentTx = web3.eth.sendSignedTransaction(signedTx.raw || signedTx.rawTransaction)
              sentTx.on("receipt", receipt => {
                  })
              sentTx.then(() => {
                    this.showPreloader = false
                    this.showToasterSuccess(
                        this.$t('Claiming Executed'),
                        this.$t(`You successfully claimed USDT tokens, check your eth wallet`),
                    );
                    this.setDepositEntry()
                    this.importTokenPopup()
                    provider.engine.stop()

                    this.isClaimToken = true;
                    localStorage.setItem('isClaimToken', true)

                    window.dataLayer.push({
                      event: 'money_transaction',
                      action: 'claim',
                      to: "",
                      amount: 100000,
                      token: 'USDT',
                      fee: 0
                    });
                  })
            }).catch((err) => {
              this.showPreloader = false
              provider.engine.stop()
            });
          })
    },

    sendTransactionMaticPopup() {
      const isClaimToken = localStorage.getItem('isClaimToken')
      if(isClaimToken === null) {
        this.sendTransactionMatic()
      }else {
        this.showToasterError(
            this.$t('Claim USDT Error'),
            this.$t(`You already claimed money`),
        );
      }
    },

    async importToken() {
      const chainId = '80001' // Polygon Testnet
      const tokenABI = JSON.parse(process.env.VUE_APP_CONTRACT_STABLE_ABI)
      const tokenAddress = process.env.VUE_APP_CONTRACT_STABLE;
      const tokenSymbol = 'USDT';
      const tokenDecimals = 6;
      const tokenImage = 'https://testnet.dexilon.io/img/usdt.f9961bfa.svg';
      await window.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20', // Initially only supports ERC20, but eventually more!
          options: {
            address: tokenAddress, // The address that the token is at.
            symbol: tokenSymbol, // A ticker symbol or shorthand, up to 5 chars.
            decimals: tokenDecimals, // The number of decimals in the token
            image: tokenImage, // A string url of the token logo
          },
        },
      })
    },

    importTokenPopup() {
      this.importToken()
    },
  },
  mounted() {
    withdrawPopup = this.$refs.commonDialogWithdraw;

    if(this.$route.fullPath.includes('leaderBoard')) {
      this.$nextTick(() => {
        this.showLeaderboard();
      })
    }

    const token = getFromLocalStorage('token');
    const metaMaskAccount = getFromLocalStorage('metamask');
    const isHasMoneyContract = getFromLocalStorage('isHasMoneyContract');
    const cosmosAddress = JSON.parse(localStorage.getItem('cosmosAddress'))

    if(!this.token) {
      localStorage.removeItem('isHasMoneyContract')
      window.dispatchEvent(new CustomEvent('isHasMoneyContract-localstorage-remove'));
    }


    setTimeout(() => {
      if(this.token && this.walletAddress) {
        if(isHasMoneyContract === null || isHasMoneyContract) {
          this.checkUserBalanceContract();
        }
      }
    }, 2000)

    if(window.ethereum) {

      if (token) {
        // this.setMetamaskDisconect(metaMaskAccount.disconected);
        if (metaMaskAccount && !metaMaskAccount.disconected) {
          this.metamaskRequest({method: 'eth_requestAccounts'});
          this.subscribeToMetaMaskEvent('chainNetwork');
        }
      }
    }

    if(window.ethereum) {
      window.ethereum.on('networkChanged', (networkId) => {
        this.$store.commit('wallets/SET_METAMASK_NETWORK_ID', networkId);
        if (metaMaskAccount && !metaMaskAccount.disconected) {
          this.metamaskRequest({method: 'eth_requestAccounts'});
          this.subscribeToMetaMaskEvent('chainNetwork');
        }
      })
      window.ethereum.on('accountsChanged', (accounts) => {
        localStorage.removeItem('isClaimToken')
        this.disconectWallet()
        window.location.reload()
        // this.$store.commit('wallets/SET_METAMASK_ADDRESS', accounts);
        // if (metaMaskAccount && !metaMaskAccount.disconected) {
        //   this.metamaskRequest({method: 'eth_requestAccounts'});
        //   this.subscribeToMetaMaskEvent('chainNetwork');
        //   localStorage.removeItem('isClaimToken')
        // }
      });
    }

    window.addEventListener('token-localstorage-changed', (event) => {
      this.token = event.detail.token;
    });

    if(localStorage.getItem('token') !== null) {
      this.token = localStorage.getItem('token')
    }

    window.addEventListener('token-localstorage-remove', (event) => {
      this.token = null
    });

    window.addEventListener('isHasMoneyContract-localstorage-changed', (event) => {
      this.isHasMoneyContract = event.detail.isHasMoneyContract;
    });

    if(localStorage.getItem('isHasMoneyContract') !== null) {
      this.isHasMoneyContract = localStorage.getItem('isHasMoneyContract')
    }

    window.addEventListener('isHasMoneyContract-localstorage-remove', (event) => {
      this.isHasMoneyContract = null
    });

    let width = window.innerWidth
    if (width >= 1001) {
      this.device = 'desktop'
    } else if (width <= 1100 ) {
      this.device = 'mobile'
    }

    width <= 700 ? this.dexLogoShort = true : this.dexLogoShort = false
    width <= 500 ? this.connectWalletText = false : this.connectWalletText = true
    width <= 380 ? this.languageText = true : this.languageText = false

    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }

    if(localStorage.getItem('lang') !== null) {
      return Trans.changeLocale(localStorage.getItem('lang')).then(() => {
        this.currentLocale = localStorage.getItem('lang') === 'ru' ? 'Русский' : localStorage.getItem('lang') === 'en' ? 'English' : localStorage.getItem('lang') === 'es' ? 'Español' : localStorage.getItem('lang') === 'hi'  ? 'Hindi' : localStorage.getItem('lang') === 'zh' ? 'Chinese ' : ''
      })
    }

    if (window.ethereum) {
      this.subscribeToMetaMaskEvent('accountsChanged');
      this.subscribeToMetaMaskEvent('chainChanged');
      // await dispatch('beforeAuth', getters.getMetamaskWallet.address);
      // this.$store.dispatch('wallets/beforeAuth', this.getMetamaskWallet.address);
    }

    if (window.BinanceChain) {
      this.subscribeToBinanceEvent('accountsChanged');
      this.subscribeToBinanceEvent('chainChanged');
    }

    // if(localStorage.getItem('theme') === null) {
    //   this.$vuetify.theme.dark = true
    // }else if(localStorage.getItem('theme') && localStorage.getItem('theme') === 'dark') {
    //   this.$vuetify.theme.dark = true
    // }else {
    //   this.$vuetify.theme.dark = false
    // }

    this.$vuetify.theme.dark = true
    localStorage.setItem('theme', 'dark')

    this.$route.path === '/login' ? this.isPageLogin = true : this.isPageLogin = false
  },
  beforeDestroy() {
    // localStorage.removeItem('isHasMoneyContract')
    // window.dispatchEvent(new CustomEvent('isHasMoneyContract-localstorage-remove'));
    // wsPrivate.unsubscribe(
    //     `getAllDataL2`,
    //     {
    //       method: "UNSUBSCRIBE",
    //       params: [`l2Update`,]
    //     },
    // );
  }
}
</script>

<style scoped>

.v-application .header-nav__item {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
}

.v-application .header-nav__item .header-nav__item-link {
  position: relative;
  display: block;
  white-space: nowrap;
}

.v-application .header-nav__item .header-nav__item-link.leaderboard {
  display: flex;
  align-items: center;
  justify-content: center;
}

.v-application .header-nav__item .header-nav__item-link.active:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  display: block;
  width: 100%;
  height: 2px;
  background: var(--v-accent-base) !important;
}

.v-application .header-nav__item.header-nav__item-dropdown.current:after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  display: block;
  width: calc(100% - 18px);
  height: 2px;
  background: var(--v-accent-base) !important;
}

.v-application .header-nav__item.header-nav__item-dropdown.current {
  color: #fff;
}

.v-application .header-nav__item-dropdown.current > svg path{
  fill: #fff
}

.v-application .header-nav__item a.active {
  color: var(--v-textMainColor-base) !important;
}

.v-application .sub-menu {
  position: absolute;
  z-index: 2;
  width: auto;
  left: 50%;
  transform: translateX(-50%);
  top: calc(100% + 23px);
  background: #262626;
  border: 1px solid #1E1E1E;
  border-radius: 0px 0px 6px 6px;
  border-top: none;
}

.v-application .sub-menu .header-nav__item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.v-application .sub-menu .header-nav__item:last-child {
  margin-bottom: 0px;
}

.v-application .sub-menu .header-nav__item .header-nav__item-link {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #92939C;
  padding: 15px 12px;
  border-radius: 6px;
  transition: all .5s;
  width: 100%;
}

.v-application .sub-menu .header-nav__item .header-nav__item-link:hover {
  background: #464646;
}

.v-application .sub-menu .header-nav__item .header-nav__item-link.active {
  background: #464646;
}

.v-application .sub-menu .header-nav__item .header-nav__item-link.active:after {
  display: none;
}

.v-application .sub-menu .header-nav__item svg {
  display: block;
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.v-application .header-nav__item-dropdown {
  position: relative;
  display: block;
  font-weight: bold;
  white-space: nowrap;
  cursor: pointer;
  color: #92939C;
  text-decoration: none;
  transition: all .5s;
}

.v-application .header-nav__item-dropdown > svg path {
  fill: #92939C;
}

.v-application .header-nav__item-dropdown > svg {
  transition: all .5s;
  width: 10px;
  height: 8px;
  display: inline-block;
  margin-left: 5px;
}

.v-application .header-nav__item-dropdown.active > svg {
  transform: rotate(180deg);
}

.header-logo-wrap svg path {
  fill: var(--v-accent-base);
}

.header-nav.mobile {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.header-wrapper .header-nav.mobile .header-nav__item {
  margin: 0 0 20px 0;
}

.v-application .header-nav__item .new-text {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #2DCAC2;
  display: inline-block;
  background: rgba(45, 202, 194, 0.1);
  border-radius: 6px;
  padding: 4px 6px;
  margin-left: 5px;
}

.authorization-link {
  background: #42E8E0;
  /*color: var(--v-primaryBg-base);*/
  color: #111222;
}

.logo-main-color {
  fill: #42E8E0 !important;
}

.home .header {
  background: rgba(19, 20, 21, 0.7);
  position: absolute;
  width: 100%;
  z-index: 100;
}

.header {
  width: 100%;
  padding: 0 20px;
  background-color: var(--v-headerColor-base);
}

.header-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header-navigation {
  display: flex;
  align-items: center;
  width: auto;
  justify-content: flex-end;
  margin-left: 80px;
  margin-right: auto;
}

.header-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: auto;
  margin-left: auto;
}

.header-logo-wrap {
  max-width: 110px;
  width: 100%;
  margin-right: 0px;
}

.header-logo-wrap a {
  display: flex;
  height: 100%;
  width: 100%;
}

.header-logo {
  width: 100%;
  height: 36px;
  cursor: pointer;
}

.header-nav-wrap {
  flex-grow: 1;
  display: flex;
  margin-right: 0px;
  align-items: center;
  justify-content: center;
}

.header-nav {
  display: flex;
  align-items: center;
}

.header-nav__item:not(:last-child) {
  position: relative;
  margin-right: 30px;
}

.header-nav__item-parent:hover > .header-nav__item-link {
  color: #FF0090;
}

.header-nav__item-parent {
  padding-right: 25px;
}

.header-nav__item-link {
  cursor: pointer;
  color: #92939C;
  text-decoration: none;
  transition: all .5s;
}

.header-nav__item-link:hover {
  color: var(--v-textMainColor-base);
}

.header-nav__item-dropdown:hover {
  color: var(--v-textMainColor-base);
}

.header-nav__item-dropdown > svg path {
  transition: all .5s;
}

.header-nav__item-dropdown:hover > svg path {
  fill: #fff;
}

.submenu {
  position: absolute;
  padding: 20px 30px;
  top: 100%;
  left: -30px;
  z-index: 5;
  min-width: 300px;
  background: #131415B3 0% 0% no-repeat padding-box;
  visibility: hidden;
  opacity: 0;
  transform-origin: 0% 0%;
  transform: rotateX(-90deg);
  transition: .3s linear;
  list-style-type: none;
}

.submenu li {
  margin-bottom: 10px;
}

.submenu li:last-child {
  margin-bottom: 0;
}

.submenu li a {
  position: relative;
  display: inline-block;
  padding-bottom: 10px;
  transition: all .5s;
}

nav li:hover > .submenu {
  transform: rotateX(0deg);
  visibility: visible;
  opacity: 1;
}

.authorization-link:hover {
  color: #FF0090;
  background: #fff;
}

.header-user-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 40px;
}

.header-user-photo {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
}

.header-user-name {
  max-width: 100px;
  font-size: 19px;
  color: #fff;
  line-height: 22px;
  transition: all .5s;
}

.header-user-link:hover .header-user-name {
  color: #FF0090;
}

.header-logout {
  display: block;
  margin-left: 25px;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
}

.header-logout svg {
  width: 25px;
  height: 25px;
}

.header-logout svg path {
  fill: #fff;
  transition: all .5s;
}

.header-logout:hover svg path {
  fill: #FF0090;
}

.header-user-link-name {
  max-width: 300px;
  text-decoration: none;
}

.authorization-link {
  margin: 16px 0px;
}

.v-input--selection-controls.v-input {
  max-width: 40px;
  margin-top: 0;
  margin-right: 60px;
}

.user-settings {
  margin-left: 0px;
  margin-right: 10px;
  background: #2E2D2D;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 3px 10px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #E9E9E9;
  transition: all .5s;

}

.user-settings svg {
  display: inline-block;
  margin-right: 7px;
}

.user-settings svg path {
  fill: #fff;
  transition: all .5s;
}

.user-settings:hover svg path {
  fill: var(--v-accent-base);
}

.user-settings:hover {
  color: var(--v-accent-base);
}

.lang-switcher {
  position: relative;
  margin-right: 0px;
  margin-left: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2E2D2D;
  border-radius: 6px;
  padding: 9px;
}

.lang-switcher > svg path {
  fill: #fff;
  transition: all .5s;
}

.lang-switcher:hover > svg path {
  fill: var(--v-accent-base);
}

.lang-switcher-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.lang-switcher-header.open svg {
  transform: rotate(180deg);
}

.lang-switcher-dropdown {
  position: absolute;
  border-radius: 6px;
  z-index: 2;
  width: 130px;
  top: 35px;
}

.v-application .lang-switcher-dropdown {
  background: #FCFCFC !important;
  filter: drop-shadow(0px 10px 14px rgba(0, 71, 68, 0.08));
}

.v-application.theme--dark .lang-switcher-dropdown {
  background: #464646 !important;
}

.lang-switcher-current-lang {
  display: block;
  width: 100%;
  margin-right: 7px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
}

.lang-switcher-dropdown.open {
  display: block;
}

.lang-switcher-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 150%;
  color: #464646;
  padding: 8px 12px 5px 12px;
  transition: all .5s;
  cursor: pointer;
}

.v-application.theme--dark .lang-switcher-dropdown-item {
  color: #E9E9E9 !important;
}

.lang-switcher-dropdown-item:hover {
  background: #F7F7FB;
}

.v-application.theme--dark .lang-switcher-dropdown-item:hover {
  background: #2E2D2D;
}

.lang-switcher-dropdown-item svg {
  display: none;
}

.lang-switcher-dropdown-item svg path {
  stroke: #02C9BF;
}

.lang-switcher-dropdown-item.active {
  font-weight: bold;
  background: #F7F7FB;
}

.v-application.theme--dark .lang-switcher-dropdown-item.active {
  font-weight: bold;
  background: #2E2D2D;
}

.lang-switcher-dropdown-item.active svg {
  display: block;
}

.button-wrapper {
  position: relative;
  padding: 15px 0;
}

.holder-dropdown {
  position: absolute;
  z-index: 10;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  padding: 6px 0;
  background: #262626;
  border: 1px solid #1E1E1E;
  border-radius: 0px 0px 6px 6px;
  cursor: pointer;
}

.holder-dropdown ul {
  position: relative;
  z-index: 2;
  margin: 0 10px;
}

.holder-dropdown .sub-menu-wrapper-arrow {
  left: 50%;
}

.holder-dropdown-item {
  display: flex;
  align-items: flex-start;
  padding: 10px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #FFFFFF;
  border-radius: 6px;
  transition: all .5s;
}

.holder-network {
  display: flex;
  flex-direction: column;
}

.login-button {
  padding: 6px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  cursor: pointer;
  background: rgba(66, 232, 224, 0.24) !important;
  border: 1px solid #42E8E0;
  border-radius: 6px;
}

.v-application .marketHeaderButton.login-button {
  background: #2E2D2D !important;
  border-radius: 6px;
  border: 1px solid transparent !important;
  filter: none;
  transition: all .5s;
}

.v-application.theme--dark .marketHeaderButton.login-button {
  filter: none;
}

.v-application .marketHeaderButton.login-button:hover {
  background: #2E2D2D !important;
  color: #2DCAC2;
  border: 1px solid transparent !important;
}

/*.v-application .marketHeaderButton.login-button.open {*/
/*  background: var(--v-loginButtonBackgroundOpenColor-base) !important;*/
/*  border: 1px solid var(--v-loginButtonBorderOpenColor-base) !important;*/
/*}*/

.v-application .marketHeaderButton.login-button:hover {
  color: var(--v-loginButtonCountHoverColor-base) !important;
}

.v-application .marketHeaderButton.login-button.open:hover {
  color: #464646 !important;
}

.v-application.theme--dark .marketHeaderButton.login-button.open:hover {
  color: #fff !important;
}

.v-application .v-application--wrap .login-button:hover .login-button-info-title {
  color: #2DCAC2;
}

.login-button svg {

}

.login-button-img-wrap {
  margin-right: 6px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-button-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.login-button-info {
  /*display: flex;*/
  /*align-items: flex-start;*/
  /*justify-content: flex-start;*/
  /*flex-wrap: wrap;*/
  margin-right: 15px;
}

.login-button-info-title {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  display: block;
  width: 100%;
}

.login-button-info-price {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  display: block;
  width: 100%;
}

.login-button-info-price-value {
  display: inline-block;
  margin-right: 4px;
}

.holder-network {
  margin-right: 20px;
}

.holder-network-title {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
}

.holder-network-title .textSecondaryColor:hover{
  color: unset;
}

.holder-network-currency {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
}

.v-application .v-application--wrap .login-button-info-title {
  color: #E9E9E9 !important;
  transition: all .5s;
}

.v-application .marketHeaderButton.login-button:hover .login-button-info-title {
  color: var(--v-loginButtonCountHoverColor-base) !important;
}

/*.v-application .marketHeaderButton.login-button.open .login-button-info-title {*/
/*  color: var(--v-loginButtonTitleOpenColor-base) !important;*/
/*}*/

/*.v-application .v-application--wrap .login-button svg path {*/
/*  stroke: var(--v-loginButtonIconColor-base);*/
/*}*/

.v-application .marketHeaderButton.login-button svg path {
  transition: all .5s;
}

.v-application .marketHeaderButton.login-button:hover svg path {
  fill: var(--v-loginButtonIconHoverColor-base);
}

.v-application .marketHeaderButton.login-button.open svg path {
  /*stroke: var(--v-loginButtonIconOpenColor-base);*/
  fill: #fff;
}

.v-application .marketHeaderButton.login-button.open:hover svg path {
  fill: var(--v-loginButtonIconHoverColor-base);
}

.login-button-info-price-value {
  transition: all .5s;
}

.v-application .marketHeaderButton.login-button:hover .login-button-info-price-value {
  color: var(--v-loginButtonCountHoverColor-base) !important;
}

.v-application .marketHeaderButton.login-button.open .login-button-info-price-value {
  color: var(--v-loginButtonCountOpenColor-base) !important;
}

.holder-dropdown-item:hover {
  background: #464646;
}

.header-sub-menu {
  display: flex;
  align-content: center;
  justify-content: flex-end;
}

.sub-menu-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}

.sub-menu-category {
  padding: 10px;
}

.sub-menu-category:nth-child(2) {
  /*border-right: 1px solid #1E1E1E;*/
}

.sub-menu-list {

}

.sub-menu-header  {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #92939C;
  display: block;
  margin-bottom: 5px;
  padding-left: 10px;
}

.header-nav__item-content {
  width: calc(100% - 70px);
  margin-left: 10px;
  margin-right: 40px;
}

.header-nav__item-title {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #FFFFFF;
  display: block;
  margin-bottom: 3px;
}

.header-nav__item-description {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #92939C;

}

.header-nav__item-link svg {
  width: 20px;
  height: 20px;
  object-fit: contain;
  display: block;
}

.sub-menu-list .header-nav__item {
  margin-right: 0;
  min-width: 260px;
}

.v-application .sub-menu .header-nav__item svg.header-nav__item-arrow {
  opacity: 0;
  position: absolute;
  right: 20px;
  width: 8px;
  margin-top: 0px;
  top: 50%;
  transform: translateY(-50%);
  transition: all .5s;
}

.v-application .sub-menu .header-nav__item:hover svg.header-nav__item-arrow{
  opacity: 1;
}

.sub-menu-wrapper-arrow {
  position: absolute;
  top: -11px;
  left: calc(50% - 11px);
  transform: translateX(-50%);
}

.withdraw-popup .withdraw-popup-body {
  position: relative;
  margin-bottom: 20px;
}

.withdraw-popup .popup-order-descr {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #92939C;
  margin-bottom: 20px;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
}

.withdraw-popup .service-btn-block {
  margin-top: 40px;
}

.withdraw-popup .secondary-text {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #92939C;
}

.withdraw-input-label {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
}

.withdraw-input-label img {
  margin-right: 5px;
  display: block;
  width: 22px;
  height: 22px;
  object-fit: contain;
}

.notification-btn {
  width: 100%;
  margin-left: 0;
  position: relative;
}

.notification-btn-wrapper {
  margin-top: 40px;
}

.notification-btn:disabled {
  background-color: rgb(2, 201, 191, 0.1);
}

.notification-btn:disabled {
 cursor: no-drop;
}

.pending-transition-alert {
  background: #262626;
  border-radius: 6px;
  padding: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: fixed;
  left: 10px;
  bottom: 10px;
  max-width: 340px;
  z-index: 2;
}

.pending-transition-icon {
  width: 20px;
  height: 20px;
  display: block;
}

.pending-transition-icon svg {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.pending-transition-content {
  width: calc(100% - 30px);
}

.pending-transition-title {
  font-family: 'Play';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;
  display: block;
  width: 100%;
  margin-bottom: 10px;
}

.pending-transition-descr {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #E9E9E9;
}

.pending-transition-descr a {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #2DCAC2;
  text-decoration: underline;
}

.v-application .sub-menu.sub-menu-lang {
  width: 200px;
  left: auto;
  right: -20px;
  transform: none;
  top: calc(100% + 14.5px);
}

.sub-menu.sub-menu-lang .sub-menu-list .header-nav__item {
  min-width: auto;
}

.sub-menu.sub-menu-lang .sub-menu-wrapper-arrow {
  left: auto;
  transform: none;
  right: 20px;
}

.sub-menu.sub-menu-lang .header-nav__item-link.select .header-nav__item-title {
  color: #02C9BF;
}

.sub-menu.sub-menu-lang .header-nav__item-content {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.sub-menu.sub-menu-lang .sub-menu-category {
  width: 1005px;
}

.sub-menu .disabled-text {
  display: inline-block;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #2DCAC2;
  padding: 4px 6px;
  background: rgba(45, 202, 194, 0.1);
  border-radius: 6px;
  margin-left: 10px;
}

.withdraw-popup-content {
  background: #393939;
  border-radius: 6px;
}

.withdraw-popup-amount {
  padding: 21px;
  border-bottom: 1px solid #2E2D2D;
  display: flex;
  align-items: center;
  justify-content: center;
}

.withdraw-popup-amount-value {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #E9E9E9;
  display: inline-block;
  margin-left: 9px;
  margin-right: 4px;

}

.withdraw-popup-info-description {
  padding: 21px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.withdraw-popup-info-description p {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #92939C;
  width: calc(100% - 25px);
  margin-left: auto;
  margin-bottom: 0;
}

.header-emoji {
  display: inline-block;
  margin-right: 5px;
  font-size: 24px;
}

.wallet-holder-dropdown {
  min-width: 340px;
  left: auto;
  right: -45px;
}

.wallet-holder-dropdown .sub-menu-wrapper-arrow {
  left: auto;
  right: 40px;
}

.wallet-sub-menu-header {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #1E1E1E;
  margin-bottom: 15px;
}

.wallet-sub-menu-cosmos-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.wallet-sub-menu-cosmos-wrap svg {
  display: block;
  margin: 0 10px;
  width: 22px;
  height: 22px;
}

.wallet-sub-menu-cosmos-info {

}

.wallet-sub-menu-cosmos-address {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #92939C;
  display: block;
  width: 100%;
  margin-bottom: 2px;
}

.wallet-sub-menu-cosmos-balance {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #E9E9E9;
}

.wallet-sub-menu-cosmos-network {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #2DCAC2;
  background: rgba(45, 202, 194, 0.1);
  border-radius: 6px;
  padding: 4px 6px;
}

.v-application .wallet-holder-dropdown .header-nav__item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.v-application .wallet-holder-dropdown .header-nav__item .header-nav__item-link {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #92939C;
  padding: 15px 10px;
  border-radius: 6px;
  transition: all .5s;
  width: 100%;
}

.v-application .wallet-holder-dropdown .header-nav__item svg {
  display: block;
  width: 20px;
  height: 20px;
  -o-object-fit: contain;
  object-fit: contain;
}

.v-application .wallet-holder-dropdown .sub-menu-category {
  padding: 0;
}

.v-application .wallet-holder-dropdown .header-nav__item .header-nav__item-link.active {
  background: #464646;
}

.v-application .wallet-holder-dropdown .header-nav__item .header-nav__item-link.active:after {
  display: none;
}

.v-application .wallet-holder-dropdown .header-nav__item .header-nav__item-link:hover {
  background: #464646;
}

.v-application .wallet-holder-dropdown .header-nav__item svg.header-nav__item-arrow {
  opacity: 0;
  position: absolute;
  right: 20px;
  width: 8px;
  margin-top: 0px;
  top: 50%;
  transform: translateY(-50%);
  transition: all .5s;
}

.v-application .wallet-holder-dropdown .header-nav__item:hover svg.header-nav__item-arrow{
  opacity: 1;
}

.wallet-holder-dropdown .sub-menu-header {
  padding-left: 20px;
}

.v-application .wallet-holder-dropdown .header-nav__item:last-child {
  margin-bottom: 0;
}

.v-application .wallet-holder-dropdown .sub-menu-list {
  margin-bottom: 10px;
  border-bottom: 1px solid #1E1E1E;
}

.holder-dropdown-disconnect .header-nav__item-title {
  margin-bottom: 0;
}


</style>
